/* eslint-disable max-len */
module.exports = {
  aOfB: '{a} di {b}',
  about: 'Informazioni',
  aboutThisItem: 'Informazioni su questo elemento',
  accessApiKeyManager: 'Accedi al Gestore chiave API per questo tenant.',
  accessControls: 'Controlli degli Accessi',
  accessControlsCopiedText: 'I controlli degli accessi vengono aggiornati immediatamente. I privilegi di sicurezza dei media verranno aggiornati nei prossimi minuti.',
  accessControlsCopiedTitle: 'Controlli degli accessi copiati con successo',
  accessControlsCopyConfirmation: 'Questa procedura rimuove tutti i controlli degli accessi esistenti da {to} e li sostituisce con i controlli degli accessi da {from}. Questa azione non può essere annullata.',
  accessControlsDescription: 'I controlli degli accessi definiscono chi può visualizzare questo medium, in base alle Organizzazioni e alle Categorie Media selezionate.',
  accessControlsHelpText: 'Gestire i controlli degli accessi per questa organizzazione. Gli utenti possono accedere ai media elencati solo se dispongono delle autorizzazioni per visualizzare le categorie di media a cui appartengono. L’applicazione di più media a un’organizzazione potrebbe richiedere un po’ di tempo per l’elaborazione. Ti preghiamo di attendere fino a quando le modifiche non diventeranno effettive e di utilizzare il pulsante Aggiorna fornito.',
  accessControlsIndeterminance: 'Nota: Le organizzazioni madri hanno sempre accesso al contenuto assegnato ai loro figli.',
  accessControlsRefreshWarning: 'Non hai salvato le modifiche. Aggiornando la pagina queste verranno eliminate. Vuoi continuare?',
  accessControlsSaveSuccess: 'Controlli degli accessi salvati con successo.',
  accessControlsTitleSection: 'Quando i controlli degli accessi vengono applicati a questa organizzazione, questi vengono delegati automaticamente alle seguenti organizzazioni tramite l’ereditarietà inversa:',
  accessControlsTooltip: 'Le organizzazioni hanno anche accesso ai contenuti a cui hanno accesso le organizzazioni discendenti. La griglia riportata di seguito non include i contenuti a cui l’organizzazione ha accesso tramite delega implicita ascendente o ereditarietà inversa.',
  account: 'Account',
  accountErrorMessage: 'Messaggio di errore dell’account',
  accountErrorMessageWarning: 'Il campo accountErrorMessage nel database sarà impostato su “Non autorizzato” per il tenant.',
  action: 'Azione | Azioni',
  actionDelete: 'cancella',
  actionLoad: 'carica',
  actionPaste: 'Incolla',
  actionRun: 'esegui',
  actionSave: 'Salva',
  actionUndoWarning: 'Questa azione non può essere annullata.',
  actionUpload: 'carica',
  actualSize: 'Dimensione Reale',
  add: 'Aggiungi',
  addABookText: 'Aggiungi un libro',
  addABookToStart: '{addABookText} per iniziare.',
  addAForm: 'Aggiungi un Modulo per iniziare',
  addAFormOnly: 'Aggiungi un Modulo',
  addAMedia: 'Aggiungere un medium',
  addAPIKey: 'Aggiungi una Chiave API',
  addAPartCollection: 'Aggiungi una {partCollection} per iniziare.',
  addAPrintSettingText: 'Aggiungi un’Impostazione di Stampa',
  addAPrintSettingToStart: '{addAPrintSettingText} per iniziare.',
  addASharedCart: 'Aggiungi un carrello condiviso',
  addATag: 'Aggiungere un Tag',
  addATemplate: 'Aggiungere un modello',
  addAllPartsCart: 'Aggiungi tutti i ricambi al carrello',
  addAnOrderQuoteEmailFormat: 'Aggiungi un Formato E-mail Ordine/Preventivo',
  addBooks: 'Aggiungi Libri',
  addBrowseFlow: 'Aggiungi Flusso di Navigazione',
  addChapter: 'Aggiungi Capitolo',
  addChildBrowseFlow: 'Aggiungi Flusso di Navigazione Figlio',
  addComment: 'Aggiungi un commento',
  addExistingPart: 'Aggiungi Parte Esistente',
  addGroupsToUsers: 'Aggiungi {groups} gruppi a {users} utenti',
  addItem: 'Aggiungi {item}',
  addMedia: 'Aggiungi Media',
  addPages: 'Aggiungi Pagine',
  addPart: 'Aggiungi una Parte',
  addReports: 'Aggiungi Report',
  addRootBrowseFlow: 'Aggiungi la Radice del Flusso di Navigazione',
  addRow: 'Aggiungi Riga',
  addTemplates: 'Aggiungere modelli',
  addToCartMessage: '{partNumber} aggiunto correttamente',
  addToUserGroup: 'Aggiungi ai Gruppi',
  addWidgetKey: 'Aggiungi una chiave widget',
  addedOn: 'Aggiunto il',
  additionalInformation: 'Informazioni Aggiuntive',
  additionalNotification: 'Notifica Aggiuntiva',
  additionalPartNumberDescription: 'Usa come campo numero parte aggiuntivo',
  address: 'Indirizzo | Indirizzi',
  addressInUse: 'Un indirizzo è già stato impostato come predefinito e non può essere cancellato',
  addressInUseSubtitle: 'Per cancellare questo indirizzo, è necessario prima rimuoverlo come predefinito.',
  addressLine: 'Riga dell‘indirizzo {number}',
  addressState: {
    confirmationMessage: 'I seguenti indirizzi non sono verificati.',
    confirmationTitle: 'Sei sicuro di voler procedere con gli indirizzi non verificati?',
    disabledVerification: 'La verifica dell’indirizzo sarà disabilitata per il campo relativo all’invio di ordini/preventivi',
    enteredAddress: 'Indirizzo inserito',
    failedToFetchSuggestions: 'Impossibile recuperare gli indirizzi suggeriti.',
    failedToLoadDetails: 'Impossibile caricare i dettagli dell’indirizzo.',
    incomplete: 'Indirizzo incompleto',
    missingSubpremise: 'Dettagli dell’indirizzo mancanti',
    noSuggestions: 'Nessun suggerimento trovato. Modificare l’indirizzo per visualizzare i suggerimenti.',
    selectAddress: '(selezionare un’opzione)',
    subpremiseMessage: 'Sembra che questo indirizzo si riferisca a un appartamento o a un complesso di uffici. Aggiungere il numero di appartamento, unità o suite per completare l’indirizzo.',
    suggested: 'Indirizzi suggeriti',
    unverified: 'Indirizzo non verificato',
    unverifiedHelpText: 'Scegliere un altro indirizzo salvato, modificare questo indirizzo o aggiungerne uno nuovo',
    unverifiedMessage: 'Non è possibile verificare questo indirizzo per la consegna.',
    verified: 'Indirizzo verificato'
  },
  admin: 'Amministrazione',
  adminCenter: 'Centro Amministrazione',
  adminCenterBanner: {
    bodyLabel: 'Corpo del banner',
    enableLabel: 'Abilita banner amministratore',
    headerGreenOption: 'Verde',
    headerLabel: 'Intestazione banner',
    headerRedOption: 'Rosso',
    headerYellowOption: 'Giallo',
    title: 'Banner interfaccia di amministrazione',
    typeLabel: 'Tipo di banner'
  },
  adminCenterMessage: 'Centro gestione del contenuto , utenti, impostazioni libreria, reportistica ed esportazioni',
  adminMessage: 'Caratteristiche aggiunte non appena diventano disponibili',
  administration: 'Amministrazione',
  advancedFilters: 'Filtri avanzati',
  affectedBookMedia: '{count} Media libro saranno aggiornati.',
  affectedProductPages: '{count} pagine prodotto verranno aggiornate.',
  affectedTemplateMedia: '{count} Modelli di libri saranno aggiornati.',
  after: 'Dopo',
  aggregatedFromChildren: 'Aggregati dai Figli',
  aiAlgorithm: 'Scanner AI',
  algorithm: 'Algoritmo',
  alignHorizontal: 'Allinea in Orizzontale',
  alignVertical: 'Allinea in Verticale',
  all: 'Tutto',
  allLibraryPages: 'Tutte le pagine della Libreria',
  allPagesAndBooks: 'Tutte le pagine e i libri',
  allUsersDisabled: 'Tutti gli utenti che appartengono al tenant saranno disabilitati.',
  alphanumeric: 'Alfanumerico',
  analyticsJSON: 'Analisi JSON',
  andCountMore: 'e altri {count}...',
  announcement: 'Annuncio | Annunci',
  any: 'Qualsiasi',
  apiAuthHeader: 'Intestazione Autorizzazione API',
  apiKey: 'Chiave API | Chiavi API',
  apiKeyAdmin: 'Amministratore Chiave API',
  apiKeyCopied: 'Valore Intestazione Autorizzazione API copiato negli Appunti',
  apiKeyDeleteMsg: 'L’eliminazione della seguente Chiave API disabiliterà il suo utilizzo da parte delle integrazioni',
  apiKeyDeleteTitle: 'Sei sicuro di voler eliminare questa Chiave API?',
  apiKeyDeleted: 'Chiave API eliminata',
  apiKeyDeletedError: 'Errore durante l’eliminazione della Chiave API',
  apiKeyInstructions: 'Si genererà una chiave una volta eseguito il Salvataggio',
  apiKeyManager: 'Gestore Chiave API',
  apiKeyNameEmpty: 'Il nome non può essere vuoto',
  apiKeyRegenError: 'Errore durante la rigenerazione della Chiave API',
  apiKeyRegenMsg: 'La rigenerazione della seguente Chiave API potrebbe disabilitare le integrazioni esistenti',
  apiKeyRegenTitle: 'Sei sicuro di voler rigenerare questa Chiave API?',
  apiKeySaved: 'Chiave API Salvata',
  apiKeyType: 'Tipo di Chiave API',
  appliesTo: 'Si applica a',
  appliesToEmpty: 'Richiede la selezione di almeno un tipo di entità',
  appliesToPopulated: 'Selezionare a quali entità può essere applicato il tag',
  apply: 'Applica',
  applyItem: 'Applica {item}',
  applyToChildItems: 'Applica al Figlio {item}',
  applyToPartOnly: 'Applica solo a questa parte',
  april: 'Aprile',
  areYouSure: 'Sei sicuro di voler eliminare {item}?',
  areYouSureCopy: 'Sei sicuro di voler copiare {item}?',
  areYouSureYouWantToDisableTheTenant: 'Sei sicuro di voler disabilitare il tenant?',
  area: 'Area',
  assembly: 'Assemblaggio | Assemblaggi',
  assemblyConfirmationTitle: 'Vuoi completare l’assemblaggio creato?',
  assemblyCreatorHelpText1: 'Questa funzione ti permette di inserire una pagina selezionata nei libri ovunque si trovi la parte {partName}, collegando automaticamente la parte e la pagina selezionata attraverso un link hotpoint. A scelta, puoi restringere l’inserimento ai soli libri selezionati.',
  assemblyCreatorHelpText2: 'La pagina selezionata viene inserita una sola volta per libro dopo la prima occorrenza di {partName}.',
  assemblyCreatorSuccessSubtitle: 'Le modifiche ai collegamenti hotpoint e all’indice del libro verranno effettuate immediatamente. I risultati della ricerca verranno visualizzati una volta completata l’indicizzazione.',
  assemblyCreatorSuccessTitle: 'Creazione dell’assieme inviata',
  assemblyStepOne: 'Fase 1: Seleziona la pagina da inserire',
  assemblyStepTwo: 'Fase 2: Scegliere i libri in cui inserire la pagina selezionata',
  asset: 'Risorsa | Risorse',
  assetsNotFound: 'Nessun {type} Trovato',
  assignBrowseFlow: 'Assegna Flusso di Navigazione',
  assignMedia: 'Assegna media',
  assignMediaToItem: 'Assegna media a questo {item}.',
  assignedOrganizations: 'Organizzazioni Assegnate',
  associateProductPage: 'Associa pagina prodotto esistente',
  associateProductPageDescription: 'Associare le pagine prodotto a questo media.',
  associateProductPageTip: 'Suggerimento: facendo clic su “Crea nuova pagina prodotto” si apre una scheda per aggiungere una nuova pagina prodotto se il prodotto che si desidera associare non esiste. Sarà comunque necessario tornare a questa pagina per associare la nuova pagina prodotto creata.',
  associateProducts: 'Associa prodotti',
  atLeastFiveError: 'Seleziona un valore non inferiore a 5.',
  attachRelatedPDFs: 'Allegare PDF delle relative pagine delle parti',
  attachment: 'Allegato | Allegati',
  attachmentEditorDescription: 'Allega immagini, video e documenti direttamente a questa entità. Nota: si troveranno nella scheda "Correlato".',
  attachmentEditorDescriptionPP: 'Allega immagini, video e documenti direttamente a questa entità.',
  attachmentFileUploadSizeError: 'La dimensione del file supera il limite di 50 MB',
  attachmentView: 'Vedi Allegati',
  attributions: 'Assegnazioni',
  august: 'Agosto',
  autoHideEmptyCards: 'Nascondi automaticamente le schede vuote',
  autoHotpoint: 'Hotpoint Automatico',
  autoPopulate: 'Popola Automaticamente',
  automaticZoom: 'Zoom Automatico',
  availability: 'Disponibilità',
  back: 'Indietro',
  backCover: 'Copertina Posteriore',
  backStitch: 'Cucitura Posteriore',
  backToLibrary: 'Torna a Libreria',
  backToSearch: 'Torna a Cerca',
  badCredentials: 'Credenziali Non Valide',
  badDefaultValueMessage: 'Il valore predefinito deve contenere tra {min} e {max} caratteri.',
  bahasaDescription: 'Descrizione in Bahasa Indonesiano',
  bahasaName: 'Nome in Bahasa Indonesiano',
  banner: 'Banner',
  banners: 'Banner',
  barColor: 'Colore barra',
  before: 'Prima',
  beginTypingToFindAnything: 'Inizia a digitare per trovare un elemento',
  beta: 'Beta',
  betaAccessKeys: 'Chiavi di accesso beta',
  betaReleaseVideo: 'Video Versione Beta',
  betaResources: 'Risorse Beta',
  blobFinder: 'Rilevatore BLOB',
  body: 'Corpo',
  bom: 'BOM',
  bomDefaultSupplier: 'Fornitore BOM Predefinito',
  bomExportSuccess: 'Esportazione BOM Riuscita',
  bomItem: 'Elemento BOM',
  bomItems: 'Elementi BOM',
  bomLayout: 'Layout della Distinta dei Materiali',
  bomListOptions: 'Opzioni distinta base',
  bomListSettings: 'Impostazioni distinta base',
  book: 'Libro | Libri',
  bookInserts: 'Inserti Libro',
  bookLabel: 'Libro | Libri',
  bookPrintingDisable: 'Disabilita Stampa Libro',
  booksAndPagesDisplay: 'Visualizza Libri e Pagine',
  boost: 'Potenzia la Ricerca',
  boostDescription: 'Aggiungi un valore superiore a 1,5 per aumentare la pertinenza della ricerca di questo tag rispetto a numeri delle parti, identificatori di media e nomi',
  boostRangeInvalid: 'L’aumento deve essere compreso tra 0,5 e 100,0',
  border: 'Bordo',
  both: 'Entrambi',
  bottom: 'Fondo',
  branding: 'Branding',
  browse: 'Sfoglia',
  browseComputer: 'Cerca nel Computer',
  browseFlow: 'Sfoglia Flusso | Sfoglia Flussi',
  browseFlowAssigned: 'Flusso di Navigazione Assegnato',
  browseFlowCopyMessage: 'Inserire un nome unico per il nuovo Flusso di Navigazione.',
  browseFlowDeleteMessage: 'Cancellare un flusso di navigazione non cancella solo il flusso di navigazione stesso, ma anche tutti i suoi flussi figli.',
  browseFlowDeleted: 'Flusso di navigazione eliminato',
  browseFlowEmptyState: 'Nessun Flusso di Navigazione definito. {new} per iniziare.',
  browseFlowHierarchy: 'Gerarchia Flusso di Navigazione',
  browseFlowMediaCategoryProductPageHelpText: 'Eliminare i criteri di ricerca “Tipo: Pagina prodotto” aggiunti per applicare le modifiche',
  browseFlowMoveToRoot: 'Trascinare qui il nodo per creare un figlio di primo livello',
  browseFlowNoAssignedOrgs: 'Nessuna organizzazione assegnata',
  browseFlowNoExistingCriteria: 'Non sono stati impostati criteri di ricerca per questo flusso di navigazione.  Utilizzare i controlli qui sopra per selezionare i criteri di ricerca.',
  browseFlowNoExistingCriteriaBelow: 'Non sono stati impostati criteri di ricerca per questo flusso di navigazione.  Utilizzare i controlli qui sotto per selezionare i criteri di ricerca.',
  browseFlowSaveFailed: 'Il flusso di navigazione non può essere aggiornato',
  browseFlowSaved: 'Flusso di Navigazione salvato',
  browseFlowSelectionRequired: 'È necessario selezionare un flusso di navigazione.',
  browseFlowSetDefaultSuccess: 'Flusso di Navigazione Predefinito impostato',
  browseFlowThumbnailDeleteFailTitle: 'Cancellazione dell’Anteprima Non Riuscita',
  browseFlowThumbnailDeleteSuccessTitle: 'Cancellazione dell’Anteprima Riuscita',
  browseFlowThumbnailUploadFailTitle: 'Caricamento dell’Anteprima Non Riuscito',
  browseFlowThumbnailUploadSuccessTitle: 'Caricamento dell’Anteprima Riuscito',
  browseFlowTooManyOrgs: 'Hai troppe organizzazioni per utilizzare l`attuale editor del flusso di navigazione. Contattare Documoto Support a {email} per richiedere supporto per la modifica dei flussi di navigazione di Documoto.',
  browserDeprecation: {
    text: 'In linea con la graduale eliminazione del supporto di Microsoft per Internet Explorer (tutte le versioni) e dei relativi problemi di sicurezza, non supporteremo più l`accesso degli utenti a questo sito tramite Internet Explorer (tutte le versioni) dopo il 30 settembre 2021.',
    title: 'Avviso Deprecazione Browser'
  },
  browserPartiallySupport: 'In questo browser si possono visualizzare differenze estetiche e altre modifiche.',
  buildHotpointLinks: 'Crea Link Hotpoint',
  buildHotpointLinksInfo: 'Questa azione prima rimuove tutti i link hotpoint esistenti dalle pagine del libro, poi crea nuovi link hotpoint tra le parti e ogni pagina di assemblaggio compatibile.',
  buildHotpointLinksTitle: 'Vuoi creare link hotpoint su questo libro?',
  bulkApplyAllOrgs: 'Applica in blocco a tutte le Org',
  bulkApplyAllOrgsModalMsg: 'Sei sicuro di voler applicare l’accesso a questo contenuto a tutte le organizzazioni? Facendo clic su “Conferma” verrà immediatamente applicato l’accesso a tutte le organizzazioni e le modifiche ai controlli degli accessi verranno salvate.',
  bulkExportConfirm: 'Vuoi esportare {n} {unit}?',
  bulkExportLimit: 'Il limite è {limit} libri per ogni esportazione',
  bulkImport: 'Importa in blocco',
  bulkIndexingLane: 'Lane per l’indicizzazione del blocco',
  bulkInsert: 'Inserimento Blocco',
  bulkPageInsertJob: 'Inserimento Pagine in Blocco',
  bulkRemoveAllOrgs: 'Rimuovi in blocco da tutte le Org',
  bulkRemoveAllOrgsModalMsg: 'Sei sicuro di voler rimuovere l’accesso a questo contenuto da tutte le organizzazioni? Facendo clic su “Conferma” verrà immediatamente rimosso l’accesso da tutte le organizzazioni e le modifiche ai controlli degli accessi verranno salvate.',
  business: 'Attività',
  button: 'Pulsante',
  cameraSettings: 'Impostazioni fotocamera',
  cancel: 'Annulla',
  cancelAssemblyCreatorSubtitle: 'La creazione dell’assieme non verrà processata.',
  cancelAssemblyCreatorTitle: 'Eliminare la creazione dell’assieme?',
  canceled: 'Annullato',
  cannotExceed100: 'Non può superare il 100%',
  cannyWidgetLoadFailure: 'Impossibile caricare l’area feedback',
  cart: 'Carrello | Carrelli',
  cartBehaviorDisabled: 'Disattiva il Messaggio Aggiungi a Quantità del Carrello',
  cartBehaviorEnabled: 'Attiva il Messaggio Aggiungi a Quantità del Carrello',
  cartBehaviorLabel: 'Aggiungi a il Comportamento Quantità del Carrello',
  cartColumn: 'Colonna Carrello | Colonne Carrello',
  cartColumn1: '1^ Colonna Prezzo del Carrello',
  cartColumn2: '2^ Colonna Prezzo del Carrello',
  cartColumn3: '3^ Colonna Prezzo del Carrello',
  cartColumnPartLocationContent1: 'Abilitare questa funzione può comportare le seguenti implicazioni:  ',
  cartColumnPartLocationContent2: 'L’unicità della riga di una parte nel carrello dipende anche dalla sua posizione all’interno di un contenuto, se applicabile.',
  cartColumnPartLocationContent3: 'Questa impostazione non può essere disabilitata a livello dell’organizzazione e verrà applicata a tutti gli utenti.',
  cartColumnPartLocationContent4: 'Se è presente un’integrazione Invia Carrello, questa impostazione non deve essere disabilitata senza aver prima contattato il Customer Success Manager Documoto.',
  cartColumnPartLocationOption: 'Attivare Dati di Localizzazione delle Parti nel Carrello',
  cartColumnPartLocationTitle: 'Sei sicuro di voler procedere all’attivazione dei Dati di Localizzazione delle Parti nel Carrello?',
  cartDisable: 'Disabilita il Carrello',
  cartEmailFailed: 'Invio Email di Carrello non riuscito',
  cartEmailSent: 'Email di Carrello inviata',
  cartEnable: 'Attiva il Carrello',
  cartErpMessage: 'Inviato correttamente a Erp',
  cartImportError: 'Errore durante l’importazione del carrello',
  cartLoadedWithItemsRemoved: '{count} articolo(i) rimosso(i) perché non disponi dell’autorizzazione per ordinarlo(i) in questo momento',
  cartSaveEnable: 'Attiva il Salvataggio del Carrello',
  cartSharedAddEdit: 'Aggiungi/Modifica Carrelli Condivisi',
  cartUpdated: 'Carrello Aggiornato',
  cartUpdatedAndRemovedCount: 'Carrello Aggiornato; {count} parti non ordinabili rimosse',
  category: 'Categoria | Categorie',
  categoryCreated: 'Categoria Creata',
  categoryNotFoundError: '403: impossibile trovare la categoria dell’entità',
  categoryUpdated: 'Categoria Aggiornata',
  centimeter: 'Centimetro | Centimetri',
  changeNotification: 'Notifica di Modifica',
  changeScope: 'Sono interessati {n} {type}',
  changeUserOrganization: 'Cambio Organizzazione',
  chapter: 'Capitolo | Capitoli',
  chapterHeader: 'Titolo Capitolo',
  chaptersOnly: 'Solo Capitoli',
  charLimitHelpText: 'Inserisci da {min} a {max} caratteri',
  chineseDescription: 'Descrizione in Cinese',
  chineseName: 'Nome in Cinese',
  circle: 'Cerchio',
  city: 'Città',
  className: 'Nome classe',
  classicAdminMessage: 'Questo ti reindirizzerà a Flex per utilizzare i moduli di gestione.',
  classicAdmins: 'Gestioni Classiche',
  classicExporter: 'Esportazione Classica',
  classicExporterMessage: 'Modulo di esportazione contenuto Legacy basato su Flash',
  classicOrganizationAdmin: 'Gestore dell’Organizzazione Classica',
  classicOrganizationAdminMessage: 'Modulo di gestione utente Legacy basato su Flash per la gestione delle org. e degli utenti',
  classicPublisher: 'Editore Classico',
  classicPublisherMessage: 'Modulo di pubblicazione Legacy basato su Flash per creazione di contenuti e impostazioni di stampa',
  classicReporting: 'Reportistica Classica',
  classicReportingMessage: 'Modulo di reportistica Legacy basato su Flash',
  classicTenantAdmin: 'Gestione Proprietario Classica',
  classicTenantAdminMessage: 'Modulo di gestione Legacy basato su Flash per le impostazioni ampie del titolare',
  clear: 'Elimina',
  clearFilters: 'Cancella i Filtri',
  clearHotpoints: 'Elimina Hotpoint',
  clearItemNumber: 'Cancella il numero dell‘articolo',
  clearItemNumberMessage: 'La cancellazione del codice prodotto comporta la rimozione dei seguenti dati:',
  clearItemNumberTitle: 'Volete cancellare il numero dell‘articolo?',
  clearSearch: 'Cancella Ricerca',
  clickAction: 'Fai clic su Azione',
  clickHereToUpload: 'Trascina il file oppure clicca per caricare una sovrascrittura.',
  clickMagnifyingGlass: 'Clicca sulla lente d’ingrandimento per andare direttamente alla Ricerca avanzata.',
  clickOkToContinue: 'Fai clic su "OK" per continuare.',
  clickToDownload: 'Clicca per il Download',
  clickToEnlarge: 'Clicca per ingrandire',
  clickToOpen: 'Clicca per Aprire',
  clipboard: 'Appunti',
  clipboardAccessError: 'Modifica le impostazioni del browser per consentire l’accesso agli Appunti',
  close: 'Chiudi',
  closed: 'Chiuso',
  collapseAll: 'Riduci Tutto',
  color: 'Colore | Colori',
  column: 'Colonna | Colonne',
  columnItemType: {
    customText: 'Testo Personalizzato',
    documentTitle: 'Titolo Documento',
    horizontalLine: 'Linea Orizzontale',
    pageName: 'Nome Pagina',
    pageNumber: 'Numero Pagina',
    printDate: 'Data di Stampa',
    tenantName: 'Nome Tenant',
    userName: 'Nome Utente'
  },
  columnMapping: 'Mappatura colonne',
  columnName: 'Nome Colonna',
  combinedPage: 'Pagina Combinata',
  combinedPageMessage: 'Diagramma in alto, elenco parti in basso',
  comingSoon: 'Imminente',
  commaDelimited: 'Delimitato da virgola',
  comment: 'Commento | Commenti',
  commentAdded: 'Commento aggiunto',
  commentCannotBeEmpty: 'Il campo Commento non può essere vuoto',
  commentDeleted: 'Commento cancellato',
  commentEdit: 'Aggiungi/Modifica del Commento',
  commentEditAll: 'Modifica Tutti i Commenti',
  commentUpdated: 'Commento aggiornato',
  commentView: 'Vedi i Commenti',
  commerceSystem: 'Sistema di Commercio',
  completed: 'Completato',
  configuration: 'Configurazione | Configurazioni',
  confirm: 'Conferma',
  confirmBrowseFlowApplyToChildren: 'Vuoi applicare questo flusso di navigazione alle organizzazioni figlie?',
  confirmBrowseFlowOverrideToChildren: 'Questo rimuoverà qualunque sovrascrittura dei flussi di navigazione definita nelle organizzazioni figlie.',
  confirmPrintSettingsApplyToChildren: 'Vuoi applicare questa impostazione di stampa alle organizzazioni figlie?',
  confirmPrintSettingsOverrideToChildren: 'Questo rimuoverà qualunque sovrascrittura delle impostazioni di stampa definita nelle organizzazioni figlie.',
  contains: 'Contiene',
  containsHeaderRow: 'Contiene la Riga di Intestazione',
  content: 'Contenuto | Contenuti',
  contentAccessControls: 'Controlli degli Accessi {content}',
  contentEntity: 'Entità del Contenuto | Entità dei Contenuti',
  contentNotFound: 'Contenuto non trovato',
  contentUpdatedQueueJob: 'Coda di Aggiornamento dei Contenuti',
  contentViewerMoreInfo: 'Altre informazioni',
  contourShape: 'Forma Contorno',
  convertEntity: 'Convertire {entity}',
  convertToEntity: 'Convertire in {entity}',
  copiedPartNumber: 'Numero di parte {partNumber} copiato',
  copy: 'Copia',
  copyAccessControls: 'Copia i Controlli degli Accessi',
  copyAccessControlsWarning: 'Questo copierà i controlli degli accessi assegnati da una Organizzazione selezionata all’attuale Organizzazione',
  copyAndRetain: 'Copia e Conserva per l’Uso dell’Integrazione',
  copyAndRetainWidget: 'Copia e conserva, questa è l’unica volta in cui il valore Autorizzazione widget sarà visibile nell’applicazione',
  copyAtoB: 'Copia {a} in {b}',
  copyBranches: 'Copia diramazioni',
  copyBranchesMessage: 'Copiare le diramazioni selezionate dal flusso di navigazione di origine in quello di destinazione.',
  copyContent: 'Copiare {type}? {name}',
  copyItem: 'Copia {item}',
  copyItemQuestion: 'Copiare {item}?',
  copyMeMessage: 'Mettimi in copia su questo messaggio',
  copyPartNumberToClipboard: 'Copia {label} negli Appunti',
  copyProduct: 'Copia prodotto',
  copyTo: 'Copia in {Target}',
  copyingItem: 'Copia di {item}',
  copyrightMessage: '© 2010-{year} Documoto Inc. Tutti i diritti riservati.',
  count: 'Contare',
  country: 'Paese | Paesi',
  coverAmpStitchPages: 'Copertina e Pagine dei Punti',
  coverPages: 'Copertine',
  createAssembly: 'Creare Assemblaggio',
  createNewProductPage: 'Crea nuova pagina prodotto',
  created: 'Creato',
  createdBy: 'Creato da {name}',
  createdDate: 'Data di Creazione',
  createdOn: 'Creato il',
  currentPassword: 'Password Corrente',
  custom: 'Personalizzazione',
  czechDescription: 'Descrizione in Ceco',
  czechName: 'Nome in Ceco',
  dashboard: 'Pannello | Pannelli',
  dashboardLibrary: 'Libreria Dashboard',
  dataInsights: 'Approfondimenti sui Dati',
  dataInsightsInfoMessage: 'Centro Report e Dashboard per approfondimenti su contenuti, utenti e dati della libreria.',
  dataMapping: 'Mappatura dei Dati/Dati Campione (fino a 10 righe)',
  dataOptions: 'Opzioni Dati',
  date: 'Data',
  dateModified: 'Data Modificata',
  debugPageBuilderPLZ: 'Debug del PLZ del generatore di pagina',
  december: 'Dicembre',
  decreaseHotpoint: 'Riduci Hotpoint',
  'default': 'Predefinito',
  defaultAddress: 'Indirizzo Predefinito',
  defaultBrowseFlow: 'Flusso di Navigazione Predefinito',
  defaultCurrencyCode: 'Codice di Valuta Predefinito',
  defaultCurrencySymbolOn: 'Simbolo della valuta per default attivato',
  defaultEmailRecipient: 'Destinatario E-mail Predefinito | Destinatari E-mail Predefiniti',
  defaultImage: 'Immagine Predefinita | Immagini Predefinite',
  defaultImagesManager: 'Gestore di Immagini Predefinite',
  defaultItemImage: 'Immagine Predefinita {item}',
  defaultPartsListLayout: 'Layout Predefinito della Lista delle Parti',
  defaultPartsListLayoutHelp: 'Layout predefinito delle parti a destra o sotto l’illustrazione',
  defaultSearchMode: 'Modalità di Ricerca Predefinita',
  defaultSearchModeHelp: 'Metodo di ricerca globale predefinito per \'contiene\' o \'esatto\'',
  defaultSortMode: 'Modalità di Ordine Predefinita',
  defaultSupplier: 'Fornitore Predefinito',
  defaultTocStateOpen: 'Stato TOC Aperto Predefinito',
  defaultTocStateOpenHelp: 'Determina se il TOC deve aprirsi automaticamente quando si visualizza un libro',
  defaultUom: 'UDM Predefinita',
  defaultValue: 'Valore Predefinito',
  defaultView: 'Visualizzazione predefinita',
  defaults: 'Impostazioni predefinite',
  defaultsAndCapabilities: 'Impostazioni predefinite e Capacità',
  'delete': 'Cancella',
  deleteAll: 'Eredita dall’Elemento Genitore.',
  deleteAnyPartnerApiKeys: 'Elimina qualsiasi Chiave API partner che è stata fornita a SmartEquip.',
  deleteContent: 'Sei sicuro di voler eliminare {type}? {name}',
  deleteFilesMessage: 'Sei sicuro di voler eliminare {count} il (i) file?',
  deleteHotpointLinksTitle: 'Sei sicuro di voler eliminare i collegamenti hotpoint?',
  deleteMessage: 'Sei sicuro di voler eliminare?',
  deletePart: {
    affectedCarts: 'Questa parte sarà rimossa in modo permanente da tutti i carrelli che la contengono.',
    deletingPartNumber: '{partNumber} sarà eliminato.',
    infoOne: 'Le eliminazioni delle parti avranno immediatamente effetto nella Libreria e in Ammin. contenuti. La parte eliminata resterà ricercabile fino alla reindicizzazione entro pochi minuti.',
    infoTwo: 'Questa azione non può essere annullata senza l’assistenza Documoto. Dopo 90 giorni il record eliminato e tutte le associazioni corrispondenti saranno cancellati in modo permanente.'
  },
  deletePartCollectionConfirmMsg: 'Sei sicuro di voler rimuovere questa {partCollection} dalla {productPage}?',
  deletePartInUse: {
    body: 'Documoto attualmente supporta solo l’eliminazione di parti che non appartengono alle pagine. Rimuovere questa parte dalle pagine pubblicate o dalle bozze per continuare con l’eliminazione.',
    submitLabel: 'Vai alla pagina dove usata',
    title: 'Questa parte appartiene alla/e pagina/e e non può essere eliminata.'
  },
  deleteProductPage: {
    deletingIdentifier: '{identifier} sarà eliminato.',
    infoOne: 'Le eliminazioni delle pagine prodotto avranno effetto immediato nella Libreria e in Ammin. contenuti. La pagina prodotto eliminata resterà ricercabile fino alla reindicizzazione entro pochi minuti.',
    infoTwo: 'Questa azione non può essere annullata senza l’assistenza Documoto. Dopo 90 giorni, il record eliminato e tutte le associazioni corrispondenti saranno cancellati in modo permanente.'
  },
  deleteRelated: 'Sei sicuro di voler eliminare {count} {type}?',
  deleteSelectedCriteria: 'Cancella Criteri Selezionati',
  deleteTagsTitle: 'Sei sicuro di voler eliminare i tag?',
  deleteTaxonMessage: 'Questo cancellerà definitivamente le classificazioni con i relativi figli.’ Sei sicuro di voler procedere?',
  deleteTaxonomyMessage: 'Questo cancellerà definitivamente tutte le classificazioni, per questa Org. o Titolare. Sei sicuro di voler procedere?',
  deleteTenantSupplier: 'Sei sicuro di voler eliminare questo fornitore per il titolare?',
  deletedItem: '{item} cancellato',
  demo: 'Demo',
  description: 'Descrizione',
  deselectAll: 'Deseleziona Tutto',
  deselectCriteria: 'Deseleziona Criteri',
  detail: 'Dettaglio | Dettagli',
  diagonal: 'Diagonale',
  diameter: 'Diametro',
  disable: 'Disabilita',
  disableAll: 'Disabilita tutto',
  disableDocumotoTenant: 'Elimina tenant Documoto',
  disableFwdReindex: 'Disabilita il Forwarding Reindex Target Media per DSW',
  disableLibraryBannerImage: 'Elimina immagine banner Libreria',
  disableSmartEquipModalTitle: 'Sei sicuro di voler disabilitare questa licenza?',
  disableTEK: 'Disattiva Accesso tramite URL Diretto',
  disableUserLogin: 'Disabilita l\'accesso con nome utente/password',
  disableUserLoginErrorMessage: 'La tua organizzazione richiede l\'autenticazione SSO. L\'accesso con nome utente/password non è consentito per il tuo gruppo utenti. Accedi utilizzando l\'SSO.',
  disableUserLoginTooltip: 'Per abilitare questa opzione è necessaria una configurazione SSO funzionante. Se l\'SSO non è configurato, gli utenti interessati perderanno l\'accesso a Documoto.',
  disabled: 'Disabilitato',
  discard: 'Eliminare',
  discardChanges: 'Elimina le modifiche',
  discardQ: 'Elimina le modifiche?',
  discountPrice: 'Prezzo Scontato',
  discounted: 'Scontato',
  discountedPrice: 'Prezzo Scontato',
  discountedTotal: 'Sconto Totale',
  displayInOrdersList: 'Mostra nell’Elenco Ordini',
  displayLocation: 'Visualizza posizione',
  displayOrder: 'Mostra Ordine',
  displayOrderDescription: 'Imposta l`ordine di visualizzazione del menu a tendina dei Filtri per i tag del tipo di contenuto',
  displaySupplierPartInfo: 'Visualizza fornitore su Info parte',
  document: 'Documento | Documenti',
  documentLabel: 'Documento | Documenti',
  documentSettings: 'Impostazioni documento',
  documotoAcademy: 'Documoto Academy',
  documotoLicensePackage: 'Pacchetto di licenza Documoto',
  domain: 'Dominio',
  domainEmptyMessage: 'Il dominio autorizzato non può essere vuoto',
  domainInvalidMessage: 'È richiesto un nome di dominio valido',
  download: 'Scarica',
  downloadBrowser: 'Scarica uno di questi grandi browser.',
  downloadFailed: 'Errore durante il download di {name}',
  downloadStarted: 'Download in corso di {name}',
  draft: 'Bozza | Bozze',
  draftBomDeleteTitle: 'Sei sicuro di voler eliminare questa parte dalla pagina?',
  draftBomDropError: 'Impossibile annidare parti a più di 5 livelli di profondità',
  draftBomEmptyField: 'Tutti i campi in Elenco Parti devono essere compilati',
  draftBomError: 'Errore nella manipolazione della bozza della Distinta Base',
  draftBomMultipleDeleteTitle: 'Sei sicuro di voler eliminare queste parti dalla pagina?',
  draftBomQuantityError: 'La quantità deve essere un numero',
  draftPage: 'Bozza di Pagina',
  draftPageDelete: 'Elimina Bozza',
  draftPageDeleteMessage: 'Bozza di pagina eliminata con successo.',
  draftPageDeleteWarning: 'Eliminando la bozza di pagina verranno rimossi gli aggiornamenti in corso.',
  draftPageLastUpdated: 'Bozza - Aggiornata l’ultima volta in data {date} da {username}',
  draftPageLoadError: 'Impossibile caricare la pagina di bozza.',
  draftPageProcessingPlz: 'Caricamento della pagina da file PLZ in corso',
  draftPagePublishInProgress: 'Pubblicazione Pagina in corso',
  draftPageSaveSuccess: 'Bozza di pagina salvata con successo.',
  draftPageSaveUnsuccessful: 'Salvataggio della bozza di pagina non riuscito.',
  draftSheetImageHotpointsFailure: 'Impossibile generare hotpoint {algorithm} per l’immagine della bozza.',
  draftValidationMessage: {
    empty: 'Nessun Errore/Avviso di Convalida',
    hotpointOrHotpointLink: 'L’articolo {item} della distinta base non ha hotpoint/collegamenti hotpoint specificati',
    item: 'ATTENZIONE: il DiBa {partNumber} non ha un numero articolo specificato',
    quantity: 'L’articolo {item} della distinta base non ha quantità specificate',
    supersede: 'L’articolo {partNumber} ha sostituito {supersededPartNumber} a causa di una sostituzione.',
    tag: 'Valore tag mancante tag {tagName} articolo {item} della distinta base',
    translationDescription: 'Descrizione traduzione in {lang} mancante articolo {item} della distinta base',
    uom: 'L’articolo {item} della distinta base non ha unità di misura specificate'
  },
  drawAutohotpointRegion: 'Disegna dimensione {shape}',
  drawMinimumArea: 'Disegna area minima',
  dropFileMessage: 'Trascina qui il file oppure clicca per caricarlo.',
  duplicate: 'Duplicato',
  duplicateSaveError: 'Voce doppia. Impossibile salvare.',
  dutchDescription: 'Descrizione in Olandese',
  dutchName: 'Nome in Olandese',
  dynamic: 'Dinamico',
  dynamicNaming: 'Denominazione Dinamica',
  ecommerce: 'eCommerce',
  ecommerceEmailFormatCreated: 'Formato E-mail E-commerce creato',
  ecommerceEmailFormatSaved: 'Formato E-mail E-commerce salvato',
  ecommerceLogo: 'Logo e-commerce',
  ecommerceUseExtOrder: 'Numero di ordine esterno per uso in e-commerce',
  edit: 'Modifica',
  editItem: 'Modifica {item}',
  email: 'E-mail',
  emailAsCsv: 'Invia tramite e-mail come CSV (Formato Richiesto per l’Importazione)',
  emailAsXlsx: 'Invia tramite e-mail come XLSX',
  emailBasicPartInfo: 'Invia Informazioni di Base delle Parti tramite e-mail',
  emailComments: 'Invia commenti tramite e-mail',
  emailDetails: 'Invia dettagli tramite e-mail',
  emailDisplayedCartColumns: 'Invia Colonne Carrello Visualizzate tramite e-mail',
  emailFormat: 'Formato E-mail',
  emailFormatTemplate: 'Modello di Formato E-mail | Modelli di Formato E-mail',
  emailList: 'Elenco E-mail',
  emailMessage: 'È richiesta un’e-mail',
  emailRecipient: 'Destinatario E-mail | Destinatari E-mail',
  emailRecipientMessage: 'Questi indirizzi riceveranno un’e-mail quando lo stato dell’ordine cambia in',
  emailSubject: 'Oggetto e-mail',
  emptyBomState: 'Nessun Elemento BOM definito per pagina. Fai clic su +{add} per iniziare',
  emptyMessage: {
    orderSuggestions: 'Sembra che non ci siano ancora dei Suggerimenti di Ordini per questa parte.'
  },
  enable: 'Attiva',
  enable3d: 'Attiva 3D',
  enable3dIllustrations: 'Attiva le illustrazioni 3D',
  enable3dThumbnails: 'Attiva anteprime 3D',
  enableAPIKeyAdmin: 'Attiva Amministratore Chiave API',
  enableAll: 'Attiva tutto',
  enableCommerce: 'Attiva eCommerce',
  enableEcommerceOrderManagement: 'Attiva gestione ordini',
  enableExportToLinkOne: 'Attiva Esportazione a LinkOne',
  enableExportToSmartEquip: 'Attiva Esportazione a SmartEquip',
  enableExporter: 'Attiva Esportatore',
  enableIframeSupport: 'Attiva supporto iFrame',
  enableKnowledgeBase: 'Abilita ricerca basata sull’IA',
  enableLibraryBetaFeatures: 'Abilita le funzioni beta della libreria',
  enableMediaCategorySearch: 'Abilita raggruppamento per categorie di media nella ricerca contestuale',
  enablePDFDownloadWarning: 'Attiva avviso di download di PDF di grandi dimensioni',
  enablePLZToDraft: 'Attiva Elaborazione PLZ in bozza',
  enablePerformanceLogging: 'Attiva il log delle prestazioni',
  enableQuickAddToCart: 'Attiva Aggiunta rapida al carrello',
  enableQuickAddToCartHelpContext: 'Impostando ‘Attiva’ si attiverà la funzione Aggiunta rapida al carrello sopra il visualizzatore di contenuti per questo contenuto.',
  enableRocketUi: 'Attiva Esperienza Utente Rocket',
  enableSmartEquipApiIntegration: 'Attiva Integrazione API SmartEquip',
  enableWidgetLogo: 'Abilita il logo widget Documoto',
  enableWidgets: 'Abilita widget',
  enabled: 'Attivato',
  encryptedKey: 'Chiave Crittografica',
  endDate: 'Data Finale',
  endDateBad: 'La data di inizio deve essere uguale o precedente alla data di fine.',
  enforceNumericSize: 'Rinforzare la Dimensione Numerica',
  englishDescription: 'Descrizione in Inglese',
  englishName: 'Nome in Inglese',
  enterReportParameters: 'Inserire i Parametri del Report',
  enterUniqueNameForNewItem: 'Inserire un nome unico per il nuovo {item}',
  enterValidEmail: 'Inserire un’e-mail valida',
  enterValidNumber: 'Inserire un numero valido',
  enterprise: 'Società',
  entityType: 'Tipo di Entità | Tipi di Entità',
  erp: 'ERP',
  erpEndpointConfig: 'Configurazione ERP-Endpoint',
  erpPartInfo: 'Minuti di durata della Cache per informazione su componente ERP',
  erpSystem: 'Sistema ERP',
  erpSystemSaved: 'Sistema ERP salvato',
  erpSystems: 'Sistemi ERP',
  error: 'Errore',
  errorDeletePageMessage: 'Si è verificato un errore durante l’eliminazione della pagina.',
  errorInputParsing: 'Problema nell’analisi dei file di input.',
  errorPageMessage: 'Si è verificato un errore.',
  errorPageTitle: 'C’è qualcosa di sbagliato...',
  errorType: {
    error: 'Errore',
    warning: 'Avviso'
  },
  essential: 'Essenziale | Essenziali',
  eta: 'ETA',
  etlJob: 'ETL',
  exact: 'Esatto',
  excelFile: 'File Excel',
  existing: 'Esistente',
  expandAll: 'Espandi Tutto',
  'export': 'Esporta',
  exportAsCSVDropdown: 'Esporta come CSV',
  exportAsCsv: 'Esporta come CSV (Formato Richiesto per l’Importazione)',
  exportAsHtml: 'Esporta come HTML',
  exportAsPdf: 'Esporta come PDF',
  exportAsPlz: 'Esporta come PLZ',
  exportAsXlsx: 'Esporta come XLSX',
  exportBasicPartInfo: 'Esporta Informazioni di Base delle Parti',
  exportCartToXlsxDisabled: 'Disabilita Esportazione del Carrello in XLSX',
  exportCartToXlsxEnabled: 'Attiva Esportazione del Carrello in XLSX',
  exportDisplayedCartColumns: 'Esporta Colonne Carrello Visualizzate',
  exportJob: 'Lavoro di Esportazione',
  exportLane: 'Esporta lane',
  exportMessage: 'Lavoro di esportazione inviato correttamente.',
  exportParts: 'Esporta Parti',
  exportPartsXlsx: 'Esporta i ricambi in XLSX',
  exportSearch: 'Esporta Ricerca',
  exporter: 'Esportazione',
  exporterMessage: 'Consente di esportare il contenuto',
  external: 'Esterno | Esterni',
  externalUrl: 'URL esterno',
  faceted: 'Faceted',
  facetedTag: 'I valori dei filtri devono essere sfaccettati',
  facetedTagTooMany: 'Il tag supera il valore limite1 unico di 1.000 tag',
  failedAction: '{action} {content} non riuscito.',
  failedProcessContentSql: 'Elaborazione Contenuti non riuscita a causa di un testo non autorizzato. Caricare nuovamente il contenuto supportato.',
  failedToCopy: 'Copia di {content} non riuscita.',
  failedToDelete: 'Cancellazione {content} non riuscita.',
  failedToLoad: 'Caricamento {content} non riuscito.',
  failedToSave: 'Salvataggio {content} non riuscito.',
  failedToSubmitFeedback: 'Impossibile inviare il feedback.',
  failedToSubmitItem: 'Impossibile inviare {item}',
  failedToUpdate: 'Aggiornamento di {content} non riuscito.',
  'false': 'Falso',
  faq: 'FAQ',
  favorites: 'Preferiti',
  favoritesLists: 'Elenco di Libri Preferiti',
  february: 'Febbraio',
  feedbackForm: 'Invia Feedback',
  feedbackFormMessage: 'Fornisci input sulle caratteristiche che vorresti visualizzare',
  field: 'Campo | Campi',
  fieldDefinition: 'Definizione Campo',
  fieldName: 'Nome campo',
  file: 'File | File',
  fileUpload: 'Caricamento del file',
  filename: 'Nome del file',
  filesSubmitted: 'File inviato/i per l’elaborazione',
  fill: 'Riempimento',
  filter: 'Filtro | Filtri',
  filterBoundsError: 'I filtri devono contenere almeno 3 caratteri',
  filterBy: 'Filtra per',
  filterOrgNameOnly: 'Filtra: Solo Nome Org.',
  filterOrgParentNames: 'Filtra: Nomi Genitore e Org.',
  filterable: 'Filtrabile',
  filterableTag: 'Tag Filtrabile',
  finnishDescription: 'Descrizione in Finlandese',
  finnishName: 'Nome in Finlandese',
  firstName: 'Nome',
  firstNameEmpty: 'Il campo nome non può essere vuoto',
  fixedHotpointSize: 'Dimensione Hotpoint Fissa',
  font: 'Font | Font',
  footer: 'Piè di pagina',
  forSearchTerm: 'per {term}',
  forgotPassword: 'Password Dimenticata',
  forgotPasswordMessage: 'Un’e-mail con le istruzioni per reimpostare la password verrà inviata al nome utente fornito.',
  forgotPasswordSuccess: 'Se il nome utente fornito risulta valido, verrà inviata un’e-mail con le istruzioni per reimpostare la password all’indirizzo in archivio.',
  form: 'Modulo| Moduli',
  formCount: 'Conteggio Moduli',
  formName: 'Nome Modulo',
  formType: 'Tipo Modulo',
  format: 'Formato',
  formattingOptions: 'Opzioni di Formattazione',
  freezeImage: 'Congela Immagine',
  frenchDescription: 'Descrizione in Francese',
  frenchName: 'Nome in Francese',
  fri: 'Ven',
  from: 'Da',
  fromDate: 'Dalla Data',
  frontCover: 'Copertina Anteriore',
  frontStitch: 'Cucitura Anteriore',
  fullScreen: 'Schermo intero',
  gdprFaqs: 'Domande frequenti sul GDPR',
  gdprMessage: 'Accedendo alla presente sezione del nostro sito web, si accetta l‘utilizzo dei cookie essenziali. Questi cookie sono essenziali per poter navigare all‘interno dei nostri Servizi. Senza i cookie, non possiamo fornire i servizi richiesti. Per maggiori informazioni, si veda la nostra {policy}.',
  general: 'Generale',
  generalSearch: 'Ricerca Generale',
  generalSearchCriteriaAlreadySet: 'I criteri di ricerca “Ricerca generale” sono già impostati.',
  generic: 'Generico',
  germanDescription: 'Descrizione in Tedesco',
  germanName: 'Nome in Tedesco',
  goTo: 'Vai a',
  goToHome: 'Vai a Home',
  goToJobManager: 'Vai al Gestore del Lavoro',
  goToPartCollections: 'Vai a {partCollections}',
  goToSearch: 'Vai a Cerca',
  gotIt: 'Ho capito',
  hashKey: 'Tasto Cancelletto',
  header: 'Intestazione',
  headerAmpFooter: 'Intestazione e Piè di pagina',
  help: 'Aiuto',
  helpCenter: 'Centro Assistenza',
  hideBookInSearchAndRecent: 'Nascondi Libri in Risultati della Ricerca e in Elementi Aggiunti Di Recente',
  hideDuplicatePages: 'Nascondi Pagine Duplicate',
  hidePageInSearchAndRecent: 'Nascondi Pagine in Risultati della Ricerca e in Elementi Aggiunti Di Recente',
  hidePartInSearchAndRecent: 'Nascondi Parti in Risultati della Ricerca e in Elementi Aggiunti Di Recente',
  highlightDescription: 'Sottolineare le parti con questo tag nell’elenco parti',
  history: 'Cronologia',
  home: 'Home',
  homePageSettings: 'Impostazioni homepage',
  homepageOnly: 'Solo homepage',
  horizontal: 'Orizzontale',
  host: 'Host',
  hotpoint: 'Hotpoint',
  hotpointCalloutBehavior: 'Comportamento callout Hotpoint',
  hotpointLink: 'Collegamento Hotpoint | Collegamenti Hotpoint',
  hotpointLinksWillBeCreated: 'I link hotpoint verranno creati in {count} {content}',
  hotpointShift: 'Hotpoint (Shift H)',
  hotpointZoomBehavior: 'Comportamento zoom Hotpoint',
  hotpointsGenerated: '{count} punti attivi trovati nell‘immagine.',
  hourlyDWSRequestLimit: 'Limite della richiesta DWS per ora',
  hourlyRESTRequestLimit: 'Limite della richiesta REST per ora',
  htmlUiUserSwitchEnabled: 'Switch HTML UI User attivato',
  hungarianDescription: 'Descrizione in Ungherese',
  hungarianName: 'Nome in Ungherese',
  icon: 'Icona',
  id: 'ID',
  identifier: 'Identificatore',
  identifierRequiredErrorMessage: 'È richiesto un identificatore',
  ignore: 'IGNORARE',
  ignoreAccessControls: 'Ignora i Controlli degli Accessi',
  ignoreMatchingTranslations: 'Ignora le Traduzioni con abbinamenti di lingue su Import',
  illustration: 'Illustrazione | Illustrazioni',
  image: 'Immagine | Immagini',
  imageDeleteMessage: 'Sei sicuro di voler eliminare questa Immagine di Pagina?',
  imageDimensionsExceededMessage: 'La dimensione massima dell’immagine in Documoto è di 65,5 megapixel (8.191 X 8.191 pixel).  La dimensione dell’immagine che stai tentando di caricare supera il limite massimo consentito e non può essere caricata. Fai clic su “Ridimensiona” per consentire a Documoto di ridimensionare e inserire l’immagine, oppure su “Annulla” per modificare l’immagine e inserirla manualmente',
  imageOptimizer: 'Ottimizzatore di Immagini',
  imageSaveFail: 'Salvataggio Immagine Non Riuscito',
  imageSaveSuccess: 'Immagini aggiornate con successo',
  imageSizeExceededMessage: 'La dimensione massima consentita del file immagine in Documoto è di {size} megabyte. La dimensione dell’immagine che stai tentando di caricare supera il limite massimo consentito e non può essere caricata. Ridimensionare l’immagine da aggiungere a questa pagina.',
  imageSizeExceededTitle: 'Dimensione Massima Immagine Superata',
  imageUploadFailure: 'Caricamento Immagine Non Riuscito',
  'import': 'Importa',
  importBOM: 'Importa distinta base',
  importBOMError: 'Elaborazione dei dati campione non riuscita; ricontrollare la sorgente di ingresso',
  importName: 'Nome importazione',
  importParts: 'Importa Parti',
  inCart: 'Nel Carrello',
  inCartDescription: 'Visualizza i tag nel carrello',
  inPartsList: 'Nell’Elenco delle Parti',
  inPartsListDescription: 'Visualizza i tag nell’elenco parti',
  inch: 'Pollice | Pollici',
  includeComments: 'Includi Commenti',
  includeCommentsAuthorAndDate: 'Includi Autore e Data Commenti',
  includeHeaderRow: 'Includi Riga di Intestazione',
  includeImages: 'Includi Immagini',
  includeNewParts: 'Includi solo “nuovi” articoli (non presenti in Documoto)',
  includePagePartDetails: 'Includi i dettagli a livello di Articolo della Pagina',
  includePagesIndex: 'Includi Indice Pagine',
  includePartDetails: 'Includi i dettagli a livello di Articolo',
  includePartsIndex: 'Includi Indice Parti',
  includePartsList: 'Includi Elenco delle Parti',
  includeSubChapters: 'Includi i Sottocapitoli',
  includeWatermark: 'Includere watermark?',
  increaseHotpoint: 'Aumenta Hotpoint',
  indefinitely: 'A tempo indeterminato',
  indexIncludeTimestamp: 'Timestamp dell’inclusione dell’indice',
  indexLane: 'Indicizza lane',
  indexQueueJob: 'Indicizza coda',
  indexed: 'Indicizzato',
  indexingConfiguration: 'Configurazione dell’indicizzazione',
  info: 'Info',
  information: 'Informazioni',
  inherit: 'Eredita',
  inherited: 'Ereditato',
  inheritedParent: 'Ereditato dall’Elemento Genitore.',
  inputSource: 'Sorgente di Ingresso',
  inputSpecification: 'Specifiche di Ingresso',
  inputType: 'Tipo di Input',
  inputTypeListboxWarning: 'Le configurazioni di ordinamento verranno visualizzate dopo il salvataggio.',
  insertDataField: 'Inserisci Campo Dati',
  integration: 'Integrazione | Integrazioni',
  integrationsAddPartToErpCart: '{action} Aggiungi Parte al Carrello ERP',
  integrationsAddToShoppingCartPricingFromErp: '{action} Aggiungi ai Prezzi del Carrello da ERP',
  integrationsDisableErp: 'Disabilita ERP',
  integrationsDoErpForQuotes: 'Esegui ERP per Preventivi',
  integrationsEnableErp: 'Attiva ERP',
  integrationsEnableFetchPartInfoFromErp: 'Attiva Recupero delle Info sulla Parte da ERP',
  integrationsEnableScopeErp: 'Attiva ERP {scope}',
  integrationsEnableSendShoppingCartToErp: 'Attiva l’Invio del Carrello a ERP',
  integrationsEnableSyncPoAddressWithErp: 'Attiva Sync. Indirizzo PO con ERP',
  integrationsErpAvailabilityMappedFrom: 'Disponibilità ERP Mappato Da',
  integrationsErpCurrencyCodeMappedFrom: 'Codice Valuta ERP Mappato Da',
  integrationsErpDiscountedPriceMappedFrom: 'Prezzo Scontato ERP Mappato Da',
  integrationsErpEtaMappedFrom: 'ETA ERP Mappato Da',
  integrationsErpMappings: 'Mappature ERP',
  integrationsErpRetailPriceMappedFrom: 'Prezzo al Dettaglio ERP Mappato Da',
  integrationsErpWholesalePriceMappedFrom: 'Prezzo All’ingrosso ERP Mappato Da',
  integrationsInvokeGetPartInfoFromClient: 'Richiamare GetPartInfo dal Cliente',
  integrationsParseAddressForType: 'Analizzare Indirizzo per Tipo',
  integrationsShoppingCartAndPartsTitle: 'Carrello e Parti',
  integrationsShoppingCartAvailability: '{action} Disponibilità del Carrello',
  integrationsShoppingCartEtaFromErp: '{action} Carrello ETA da ERP',
  internalApiKey: 'Chiave API interna',
  internalDescription: 'Descrizione Interna',
  internalName: 'Nome Interno',
  internalNameOptional: 'Il tuo identificatore per il tag',
  internalNameRequired: 'È richiesto un nome',
  invalidDecimals: 'Sono consentite solo due cifre decimali',
  invalidField: '{field} non è valido',
  invalidFileType: 'Tipo di file non supportato. Fare riferimento al Supporto Tecnico Documoto per una lista completa delle estensioni supportate.',
  isSearchable: 'È Consultabile',
  isSystem: 'È un Sistema',
  italianDescription: 'Descrizione in Italiano',
  italianName: 'Nome in Italiano',
  item: '#',
  itemAlt: 'Item',
  itemCopied: '{item} copiato',
  itemDeleted: '{item} cancellato',
  itemDetails: 'Dettagli articolo',
  itemInProgress: '{item} in corso',
  itemInformation: 'Informazioni {item}',
  itemMustBeLteItem: '{itemA} deve essere uguale o precedente a {itemB}.',
  itemMustBeUnique: '{item} deve essere unico',
  itemMustBeUniqueAndNotEmpty: '{item} deve essere unico ed è obbligatorio',
  itemName: 'Nome {item}',
  itemSaved: '{item} salvato',
  itemSpecification: 'Specifiche dell’articolo',
  january: 'Gennaio',
  japaneseDescription: 'Descrizione in Giapponese',
  japaneseName: 'Nome in Giapponese',
  job: 'Lavoro | Lavori',
  jobManager: 'Gestore del Lavoro',
  jobManagerMessage: 'Esporta, pubblica e stampa/scarica lavori',
  july: 'Luglio',
  june: 'Giugno',
  knowledgeBase: {
    config: {
      fetchUsage: 'Recupera utilizzo',
      maxTokensDefault: 'Numero massimo predefinito di token al mese',
      maxTokensOverride: 'Numero massimo di token sovrascrivibili al mese',
      noData: 'Nessun dato di configurazione disponibile.'
    },
    errors: {
      maxFileSizeExceeded: 'Il file supera il limite di dimensione per la base di conoscenze.',
      maxTokensExceeded: 'Hai raggiunto il limite di token.',
      pageNavigationFailed: 'Impossibile accedere alla pagina.'
    },
    feedback: {
      prompt: 'Grazie per averci informato. Cosa c’era che non andava in questa risposta?',
      reasons: {
        hardToUnderstand: 'Difficile da capire',
        incorrect: 'Sbagliata',
        missingInfo: 'Informazioni mancanti',
        offTopic: 'Non pertinente'
      },
      submitted: 'Il tuo feedback è stato inviato.'
    },
    library: {
      buttonText: 'Chiedi all’IA',
      disclaimer: 'L’IA di Documoto può commettere errori. Verifica sempre la correttezza delle risposte.',
      inputPlaceholder: 'Fai una domanda...',
      noContent: 'Nessun contesto disponibile per questo documento.',
      promptDefault: 'Le risposte alle domande sono fornite solo in base a questo documento. Fai una domanda alla volta.',
      reference: 'PDF di riferimento',
      serviceError: 'Errore durante la generazione del contesto.',
      title: 'Ricerca basata sull’IA'
    },
    tenantKnowledgeBase: 'Base di conoscenze del titolare',
    usage: {
      inputTokens: 'Token di input totali',
      noData: 'Nessun dato di utilizzo disponibile.',
      outputTokens: 'Token di output totali',
      title: 'Riepilogo sull’utilizzo dei token',
      totalTokens: 'Totale token utilizzati'
    }
  },
  koreanDescription: 'Descrizione in Coreano',
  koreanName: 'Nome in Coreano',
  label: 'Etichetta | Etichette',
  labelKey: 'Tasto Etichette',
  landscape: 'Orizzontale',
  laneConfiguration: 'Configurazione del lane',
  language: 'Lingua',
  largePDFDownloadWarning: 'A causa della grande dimensione del file PDF, il caricamento e la visualizzazione del documento nell’applicazione potrebbero richiedere più tempo del solito; si prega di attendere con pazienza il download del file per visualizzarlo.',
  lastGenerated: 'Ultima Chiave Generata',
  lastModifiedDate: 'Data Ultima Modifica',
  lastName: 'Cognome',
  lastNameEmpty: 'Il campo cognome non può essere vuoto',
  lastUpdatedOn: 'Data dell’ultimo aggiornamento',
  layout: 'Layout',
  layoutOptions: 'Opzioni Layout',
  ledger: 'Registro contabile',
  left: 'Sinistra',
  legal: 'Legale',
  letter: 'Lettera',
  library: 'Libreria',
  libraryAdmin: 'Gestione della Libreria',
  libraryBannerLogo: 'Logo Banner della Libreria',
  librarySettings: 'Impostazioni della Libreria',
  librarySettingsDescription: 'Queste impostazioni controllano i vari elementi e le opzioni della Libreria. Prestare attenzione durante le modifiche. Contattare i Servizi Documoto per ulteriori informazioni.',
  licenseConfiguration: 'Configurazione della licenza',
  line: 'Linea',
  lineTool: 'Strumento Riga',
  link: 'Link | Link',
  listBox: 'Casella di Riepilogo',
  listBoxValue: 'Valore Casella Elenco | Valori Casella Elenco',
  listValue: 'Valore Elenco | Valori Elenco',
  load: 'Carica',
  loadMore: 'Carica altri',
  loading: 'Caricamento in corso',
  loadingParts: 'Caricamento ricambi',
  locale: 'Impostazioni locali',
  logiReportName: 'Nome Report Logi',
  logiReportToggle: 'Report Logi?',
  login: 'Accesso',
  loginBackground: 'Accesso Background',
  loginGDPRMessageBeginning: 'Questo sito utilizza i cookie. Continuando ad utilizzare questo sito web si dà il consenso all‘utilizzo dei cookie. Per maggiori informazioni, si veda la nostra ',
  loginGDPRMessageEnd: 'e le nostre',
  loginSSO: 'Accesso SSO',
  logo: 'Logo | Loghi',
  logout: 'Chiusura sessione',
  lookupLoadParts: 'Ricerca/Carica Parti da Documoto su Importa',
  lowerBound: 'Limite Inferiore',
  mOfNShown: '{m} di {n} visualizzati',
  mToM: 'M2M',
  mainInfo: 'Informazioni Principali',
  mainLogo: 'Logo Principale',
  makePagesDivisibleBy: 'Rendi le Pagine Divisibili Per:  ',
  manageItem: 'Gestisci {item}',
  management: 'Gestione',
  manuallyResetPassword: 'Reimposta la Password manualmente',
  manuallySetPassword: 'Imposta la Password manualmente',
  march: 'Marzo',
  margin: 'Margine | Margini',
  markdown: 'Ribasso',
  maxCharHelpMessage: 'Imposta un limite massimo di caratteri compreso tra {min} e {max}.',
  maxCharacters: 'N. max di caratteri',
  may: 'Maggio',
  media: 'Media | Media',
  mediaBookDeleteMessage: 'Cancellando questo medium si rimuove l’accesso a questo contenuto sia nella Libreria che nell’Amministrazione del Contenuto e non sarà più disponibile per gli utenti o gli Amministratori dei Contenuti. Qualsiasi parte o pagina trovata in questo libro, che non si trova in altri libri, non sarà più disponibile nella Libreria.',
  mediaCategory: 'Categoria Media | Categorie Media',
  mediaCategoryEditor: 'Editor Categoria Media',
  mediaCategoryName: 'Nome della Categoria Media',
  mediaCategoryNameMissing: 'Tutte le categorie media richiedono un nome',
  mediaDeleteMessage: 'Cancellando questo modello lo si rimuoverà dall’Amministrazione del Contenuto e non sarà più disponibile per la copia su nuovi Media.',
  mediaDeleteSuccessText: 'Verrà rimosso dagli elenchi una volta completata l’indicizzazione.',
  mediaDescription: 'Descrizione media',
  mediaIdentifier: 'Identificatore media',
  mediaIdentifierDescription: 'Il numero di media interno che gli utenti finali vogliono cercare',
  mediaName: 'Nome media',
  mediaPrintSettingsSaveSuccess: 'Impostazioni Stampa dei Media salvati',
  mediaWhereUsed: 'Media Dove Sono Usati',
  menu: 'Menu',
  merge: 'Unisci',
  mergeOrOverrideMessage: 'Si desidera sovrascrivere o unire questi articoli?',
  mergeWarning: 'Dopo l’importazione dei dati verranno aggiornate le parti esistenti e aggiunte le nuove voci',
  message: 'Messaggio',
  messageLevel: 'Livello di Messaggio',
  messageMessage: 'È necessario un messaggio',
  metadata: 'Metadati',
  microsite: 'Microsito | Micrositi',
  micrositeAdmin: {
    cardSubtitle: 'File di contenuti compresso e informazioni di inserimento HTML',
    cardTitle: 'Contenuto del sito',
    errorRequiredFile: 'È necessario un file ZIP con i contenuti del sito',
    fieldFile: 'File ZIP con i contenuti del sito',
    fieldPoint: 'Punto di ingresso HTML'
  },
  minArea: 'Area Minima',
  minAreaMessage: 'È richiesto un valore minimo. Il valore non può superare un intervallo compreso tra 1 e 1.500.  Deve essere un valore intero.',
  minCharacters: 'N. min di caratter',
  minMaxCharHelpMessage: 'Imposta un valore compreso tra {min} e {max} per i limiti minimo e massimo di caratteri. Il valore massimo deve essere maggiore o uguale al valore minimo.',
  mine: 'Mio',
  miscellaneous: 'Miscellanea',
  mon: 'Lun',
  month: 'Mese',
  moreInfo: 'Altre informazioni',
  multipleAlternatingPages: 'Pagine Alternate Multiple',
  multipleAlternatingPagesMessage: 'Immagini sulle pagine 1 e 3, elenco parti sulle pagine 2 e 4.',
  multiplePages: 'Pagine Multiple',
  multiplePagesMessage: 'Immagine sulla propria pagina seguita dalle pagine con l’elenco delle parti',
  myCart: 'Il Mio Carrello | I Miei Carrelli',
  nItemsCreated: '{n} {items} Creati',
  nItemsDeleted: '{n} {items} Cancellati',
  nOfMItems: '{n} di {m} {items}',
  name: 'Nome',
  nameDescriptionHelpText: 'Nome e descrizione opzionale',
  navigation: 'Navigazione',
  'new': 'Nuovo',
  newAPIKey: 'Nuova Chiave API',
  newERPSystem: 'Nuovo sistema ERP',
  newItem: 'Nuovo {item}',
  newKeyGenerated: 'Nuova Chiave di Integrazione Generata, Copiare e Conservare per l’uso futuro',
  newMediaCategory: 'Nuova Categoria Media',
  newPassword: 'Nuova Password',
  newTenant: 'Nuovo titolare',
  newWidgetKey: 'Nuova chiave widget',
  newWidgetKeyGenerated: 'Nuova chiave widget generata, copiare e conservare per l’uso futuro',
  newsItem: 'Elemento Notizie | Elementi Notizie',
  noAPIKeys: 'Nessuna Chiave API definita.',
  noData: 'Nessun Dato',
  noFileSelected: 'Nessun file selezionato',
  noFilesSelected: 'Nessun File Selezionato',
  noFormsMessage: 'Nessun Modulo definito.',
  noIllustrationFound: 'Nessuna Illustrazione Trovata',
  noImageFound: 'Nessuna Immagine Trovata',
  noItemAddedToTarget: 'Nessun {item} aggiunto al {target}. ',
  noItemAvailable: 'Nessun {item} disponibile',
  noItemFound: 'Nessun {item} trovato.',
  noItemSelected: 'Nessun {item} selezionato',
  noItemsFound: 'Nessun Elemento Trovato',
  noMediaDefined: 'Nessun media definito',
  noMoreResults: 'Nessun altro risultato',
  noPartCollectionsFound: 'Nessun {partCollection} trovato.',
  noPartsSelected: 'Nessuna parte selezionata.',
  noPrice: 'Richiedi il Prezzo',
  noResults: 'Nessun risultato',
  noSearchResultsHelpText: 'Nessun risultato trovato',
  noSearchableCategories: 'Nessuna categoria ricercabile',
  noSearchableTags: 'Nessun tag consultabile',
  noSuggestions: 'Nessun suggerimento per il termine di ricerca',
  noSupercedingPartsFoundForPartNumber: 'Nessuna parte sostitutiva trovata per questo numero di parte.',
  noTagsFound: 'Nessuna etichetta trovata',
  noTenantSuppliers: 'Nessun fornitore assegnato al titolare.',
  noUnsavedChanges: 'Nessuna Modifica Non Salvata',
  noWidgetKeys: 'Nessuna chiave widget definita.',
  node: 'Nodo',
  nonSearchableFieldsSuccessfullyUpdated: 'Campi non ricercabili aggiornati correttamente.',
  none: 'Nessuno',
  norwegianDescription: 'Descrizione in Norvegese',
  norwegianName: 'Nome in Norvegese',
  notAvailable: 'N/D',
  notImplemented: 'Non Implementato',
  notMapped: 'Non Mappato',
  notOrderable: 'Non Ordinabile',
  notSelected: 'Non selezionato',
  notification: 'Notifica | Notifiche',
  notificationsMessage: 'Annunci importanti e novità',
  november: 'Novembre',
  numberOf: '# di {item}',
  numeric: 'Numerico',
  october: 'Ottobre',
  of: 'di',
  off: 'Disattivo',
  offlineContent: 'Contenuto Offline',
  ok: 'Ok',
  oldPassword: 'Vecchia password',
  on: 'Attivato',
  opacity: 'Opacità',
  open: 'Aperto',
  openItem: '{item} aperto',
  openTab: 'Apri il link in una nuova scheda',
  optimizeIndexJob: 'Ottimizza Indice',
  optionalConfiguration: 'Configurazione facoltativa | Configurazioni facoltative',
  options: 'Opzioni',
  order: 'Ordine | Ordini',
  orderAttachmentHelpText: 'Puoi allegare fino a 10 file, ciascuno con dimensione massima di 50 MB. Formati di file consentiti: pdf, doc, docx, xls, xlsx, txt, rtf, ppt, pptx, xml, zip, jpg, jpeg, gif, png, bmp, tiff, tif, mp4, mpg, mpeg, avi, mov, rm, wmv, flv, f4v, svg',
  orderDisable: 'Disabilita Cronologia Ordini',
  orderEmailRecipient: 'Destinatario E-mail d’Ordine | Destinatari E-mail d’Ordine',
  orderEntity: 'Entità Ordine | Entità Ordini',
  orderField: {
    nameMessage: 'Se cambi il nome del campo Ordine/Preventivo, assicurati di aggiornare tutti i moduli Ordine/Preventivo o i formati e-mail che utilizzano questo campo.'
  },
  orderFieldCopyMessage: 'Inserire un nome univoco per il nuovo campo Ordine/Preventivo',
  orderFieldUneditableRequired: 'Impostare un campo Ordine/Preventivo come necessario e non modificabile dall’utente può rendere impossibile il completamento del tuo modulo Ordine/Preventivo. Verificare i moduli Ordine/Preventivo che possono essere completati.',
  orderFieldsEmptyMessage: 'Nessun campo Ordine/Preventivo definito.',
  orderFieldsEmptyPrompt: 'Aggiungi un campo Ordine/Preventivo',
  orderForm: {
    uniqueNameInputHint: 'Inserire un nome unico per il nuovo Modulo.'
  },
  orderFormField: 'Campo Ordine/Preventivo | Campi Ordine/Preventivo',
  orderFormLayout: 'Layout modulo Ordine/Preventivo | Layout modulo Ordine/Preventivo',
  orderFormSetDefault: 'Modulo Ordine/Preventivo Predefinito',
  orderFormType: 'Modulo d’Ordine',
  orderLayout: 'Ordine Layout | Ordini Layout',
  orderManagementApprover: 'Approvatore per la Gestione dell’Ordine',
  orderManagementDisable: 'Disabilita Amministrazione Gestione del Lavoro',
  orderManagementViewer: 'Visualizzatore Gestione dell’Ordine',
  orderNumber: 'Numero di Ordine',
  orderQuoteDeleteWarning: 'Impossibile eliminare i campi applicati a un modulo ordine o preventivo, utilizzati in un modello email o utilizzati in ordini o preventivi inviati in precedenza.',
  orderQuoteEmail: 'E-mail Ordine/Preventivo | Email Ordini/Preventivi',
  orderQuoteEmailFormat: 'Formato E-mail Ordine/Preventivo | Formati E-mail Ordini/Preventivi',
  orderQuoteEmailFormatCopyMessage: 'Seleziona una lingua per il nuovo Formato E-mail Ordine/Preventivo.',
  orderQuoteFetchError: 'Errore durante l’acquisizione dei dati del Modulo di Ordine/Preventivo',
  orderQuoteForm: 'Modulo d‘ordine/preventivo | Moduli d‘ordine/preventivi',
  orderQuoteFormSaved: 'Modulo Ordine/Preventivo salvato',
  orderQuoteSaveConfirmation: 'Salvare le modifiche apportate ai moduli di Ordine/Preventivo dell’Organizzazione?',
  orderQuoteSaveError: 'Errore durante il salvataggio dei dati del Modulo di Ordine/Preventivo',
  orderStatus: 'Stato Ordine/Preventivo | Stati Ordine/Preventivo',
  orderStatusDeleteMessage: 'Questo stato è stato usato per alcuni ordini e non può essere cancellato.',
  orderSubmittedMessage: 'Inviato Correttamente',
  orderSuggestion: 'Suggerimento di Ordine | Suggerimenti di Ordine',
  orderSuggestionEnable: 'Attiva Suggerimenti di Ordine',
  orderSuggestionRemovalWarning: 'La parte non verrà più mostrata come suggerimento d’ordine. | Le parti non verranno più mostrate come suggerimenti d’ordine.',
  orderSuggestionThreshold: 'Limite Suggerimenti di Ordine',
  orderable: 'Ordinabile',
  orderableDescription: 'La parte può essere aggiunta al carrello e acquistata',
  orderableLocal: 'Ordinabile su questa pagina',
  orderableLocalBlocked: 'Parte non Ordinabile Globalmente',
  ordersLogo: 'Logo Ordini',
  ordersMessage: 'Cronologia invio di ordini',
  org: 'Org.',
  orgAccessControlsWarning: 'Nota: le organizzazioni antenate (come genitori o nonni) ottengono automaticamente l’accesso ai contenuti assegnati alle organizzazioni discendenti (come figli o nipoti).',
  orgEmailRecipients: 'Destinatari E-mail Org.',
  orgNameOnly: 'Solo Nome Org.',
  organization: 'Organizzazione | Organizzazioni',
  organizationAdmin: 'Amministratore dell’Organizzazione',
  organizationAdminBrowseFlow: 'Un’Organizzazione può usare il flusso di navigazione predefinito, in alternativa è possibile sovrascrivere e utilizzare un altro flusso di navigazione.',
  organizationAdminMessage: 'Controlli della gestione utente e impostazioni org',
  organizationEmailRecipients: 'Destinatari E-mail Organizzazione',
  organizationEmpty: 'Deve essere selezionata l’Organizzazione',
  organizationEnforceAccessControlsForQuickAdd: 'Applica i controlli per l’accesso per un’aggiunta rapida',
  organizationKey: 'Tasto Organizzazione',
  organizationLibrarySettingsDescription: 'Queste impostazioni controllano i vari elementi e le opzioni della Libreria a livello dell’Organizzazione. Prestare attenzione durante le modifiche. Contattare i Servizi Documoto per ulteriori informazioni.',
  organizationMoveToRoot: 'Trascina qui per spostare la radice',
  organizationName: 'Nome organizzazione',
  organizationRearrange: 'Riordinare l’Organizzazione',
  organizationRearrangeDescription: 'La struttura dell’Organizzazione genitore-figlio definisce molti attributi ereditabili di un`Organizzazione come le Impostazioni di Stampa, gli Stili e altre. Trascina le Organizzazioni per creare la gerarchia desiderata.',
  organizationReportSettingsSuccessMessage: 'Impostazioni report salvate',
  organizationSelect: 'Seleziona Organizzazione',
  organizationTags: 'Tag di Organizzazione',
  organizationsEmpty: 'Sembra che tu non abbia ancora creato nessuna organizzazione',
  orientation: 'Orientamento',
  other: 'Altro',
  otherSettings: 'Altre Impostazioni',
  outboundCustomerIdParameter: 'Nome Parametro ID del Cliente in Uscita',
  outboundSessionIdParameter: 'Nome Parametro ID della Sessione in Uscita',
  outlineMode: 'Modalità Contorno (Shift O)',
  output: 'Output',
  outputCatalog: 'Catalogo Output',
  outputDefinition: 'Definizione Output | Definizioni Output',
  outputDefinitionDeleted: 'Definizione Output cancellata',
  outputDefinitionSaved: 'Definizione Output salvata',
  outputDestination: 'Destinazione di Output',
  outputFileName: 'Nome File Output',
  outputName: 'Nome Output',
  outputSpecification: 'Specifiche di Output',
  outputSubType: 'Sottotipo Output',
  outputType: 'Tipo Output',
  overridden: 'Sovrascritto',
  overriddenByOrg: 'Sovrascritto dall’Org.',
  override: 'Sovrascrivi',
  overrideBrowseFlow: 'Sovrascrivi Flusso di Navigazione',
  overrideFacetLimitValue: 'Sovrascrivere il valore limite del facet',
  overrideFontSettings: 'Sovrascrivi Impostazioni Font',
  overrideHotpointScale: 'Sovrascrivi Scala Hotpoint',
  overrideOrderForm: 'Sovrascrivi Modulo d’Ordine',
  overridePdfNamingStandard: 'Sovrascrivi standard di denominazione file PDF',
  overridePrintSettings: 'Sovrascrivi Impostazioni di Stampa',
  overrideQuoteForm: 'Sovrascrivi Modulo di Preventivo',
  overrideSvgOpacity: 'Sovrascrivi Opacità SVG',
  overrideWarning: 'Con l’importazione dei dati verrà sostituita la distinta base corrente',
  owner: 'Proprietario | Proprietari',
  page: 'Pagina | Pagine',
  pageBomPartsDeleted: '{count} parti nella BOM della pagina non saranno accessibili tramite {filename}.',
  pageBuilder: 'Generatore di Pagina',
  pageBulkErrorTooManyBooks: 'Limitare il numero di libri selezionati a non più di 1.000',
  pageBulkInsertBooksConfirmInsertAfter: 'Questo inserirà {replacement} dopo {original} in {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertBooksConfirmInsertBefore: 'Questo inserirà {replacement} prima {original} in {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertBooksConfirmInsertReplace: 'Questo inserirà {replacement} e rimuoverà {original} da   {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertConfirmInsertAfter: 'Questo inserirà {replacement} dopo {original} in {whereUsedBookCount} {bookUnits} e {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmInsertBefore: 'Questo inserirà {replacement} prima {original} in {whereUsedBookCount} {bookUnits} e {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmInsertReplace: 'Questo inserirà {replacement} e rimuoverà {original} da {whereUsedBookCount} {bookUnits} e {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmTitle: 'Vuoi completare l’inserimento del blocco?',
  pageBulkInsertDiscard: 'L’inserimento del blocco non verrà processato.',
  pageBulkInsertHelpText: 'Questa funzione permette di inserire la pagina source {thisDisplayName} nelle parti del libro selezionate in cui esiste già un’altra pagina {originalDisplayName}. Facoltativamente, puoi anche rimuovere {originalDisplayName} da quei libri.',
  pageBulkInsertInsertAfter: 'Inserire {replacement} DOPO {original}',
  pageBulkInsertInsertBefore: 'Inserire {replacement} PRIMA di {original}',
  pageBulkInsertInsertReplace: 'Inserire {replacement} e RIMUOVERE {original}',
  pageBulkInsertScopeAll: 'Tutti i {type} che hanno la pagina target {originalDisplayName} ({whereUsedCount} {units})',
  pageBulkInsertScopeNone: 'Nessuno dei  {type} che ha la pagina target  {originalDisplayName}',
  pageBulkInsertScopeSome: 'Alcuni dei {type} che hanno la pagina target  {originalDisplayName}',
  pageBulkInsertStep1: 'Fase 1: Trovare una pagina target desiderata',
  pageBulkInsertStep2: 'Fase 2: Decidere come inserire o sostituire le pagine',
  pageBulkInsertStep3: 'Fase 3: Scegliere i libri su cui applicare l’inserimento del blocco.',
  pageBulkInsertStep4: 'Fase 4: Scegliere i modelli su cui applicare l’inserimento del blocco.',
  pageBulkInsertSuccessBody: 'Le modifiche all’indice del libro verranno effettuate immediatamente. I risultati della ricerca verranno visualizzati una volta completata l’indicizzazione.',
  pageBulkInsertSuccessTitle: 'Lavoro inserimento del  Blocco inviato',
  pageBulkInsertTemplatesConfirmInsertAfter: 'Questo inserirà {replacement} dopo {original} in {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertTemplatesConfirmInsertBefore: 'Questo inserirà {replacement} prima {original} in {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertTemplatesConfirmInsertReplace: 'Questo inserirà {replacement} e rimuoverà {original} da   {whereUsedTemplateCount} {templateUnits}.',
  pageComposer: 'Page Composer',
  pageCreated: 'Pagina Creata',
  pageDeleteMessage: 'Le eliminazioni delle parti avranno effetto immediato nella Libreria e in Ammin. contenuti. La parte eliminata resterà ricercabile fino alla reindicizzazione entro pochi minuti.',
  pageDeleteMessage2: 'Questa azione non può essere annullata senza l’assistenza Documoto. Dopo 90 giorni il record eliminato e tutte le associazioni corrispondenti saranno cancellati in modo permanente.',
  pageDescription: 'Descrizione pagina',
  pageDraftsDeleted: 'Le pagine bozza associate a questa pagina saranno eliminate in modo permanente.',
  pageFile: 'File Pagina',
  pageFileRequired: 'È richiesto un file pagina.',
  pageFilename: 'Nome file pagina',
  pageFilenameDeleted: '{filename} sarà eliminato.',
  pageFit: 'Adattamento Pagina',
  pageHeader: 'Intestazione Pagina',
  pageLabel: 'Pagina | Pagine',
  pageLayout: 'Layout Pagina',
  pageName: 'Nome pagina',
  pagePart: 'Parte Pagina | Parti Pagina',
  pagePartData: 'Dati Pagina',
  pagePartLevelDetails: 'Pagina Articolo Ordinabile/Disponibile, Pagina Etichette Articolo',
  pagePartNumberVisible: 'Numero Parte di Pagina Visibile',
  pagePartOrderable: 'Parte di Pagina Ordinabile',
  pagePartOrderableDescription: 'Parte Ordinabile da questa pagina',
  pagePartTag: 'Tag Parte di Pagina | Tag Parte di Pagina',
  pagePartVisibleDescription: 'Numero di Parte visibile in questa pagina',
  pageToPartCollectionFailure: 'Impossibile aggiungere la pagina {name} come Raccolta ricambi.',
  pageUpdated: 'Pagina Aggiornata',
  pageUsageDataCouldNotBeLoaded: 'I dati di utilizzo della pagina non possono essere caricati',
  pageViewer: 'Visualizzatore di Pagina',
  pageWidth: 'Larghezza Pagina',
  pagesWhereUsed: 'Pagine Dove Si Usano',
  parentName: 'Nome del Genitore',
  part: 'Parte | Parti',
  partCode: 'Codice della Parte | Codici della Parte',
  partCodeAddError: 'Impossibile aggiungere Codici Parti',
  partCodeErrorEmpty: 'Impossibile salvare: Il codice della parte non può essere vuoto',
  partCodeErrorInUse: 'Questo codice della parte è in uso da altre parti di Documoto e non può essere cancellato. Contattare l’Assistenza Documoto a support{\'@\'}documoto.com per ricevere supporto.',
  partCodeErrorNotFound: 'Questi codici della parte non possono essere cancellati perché non sono stati trovati. Assicurarsi che tutte le modifiche siano state salvate.',
  partCodesManager: 'Gestione dei Codici delle Parti',
  partCodesMessage: 'I codici parte possono essere utilizzati al posto dei numeri della parte e spesso vengono utilizzati per indicare quando gli articoli della DBA sono obsoleti, non disponibili o sono solo articoli di riferimento (es. \'PNNA\', \'-\', \'REF\').',
  partCollection: 'Raccolta ricambi | Raccolte ricambi',
  partCollectionsDescription: 'Aggiungi fino a 20 {parts} {pages} da visualizzare come {collections} in questa {productPage}.',
  partCollectionsDescription2: 'Le {collections} selezionate definiscono quali {parts} saranno disponibili agli utenti finali per l\'accesso rapido o l\'ordinazione.',
  partCollectionsDescription3: 'L\'ordine definito di seguito determina come verranno visualizzati nel Visualizzatore libreria {productPage}.',
  partCollectionsLimitError: 'È consentito un massimo di {limit} {item1} per {item2}.',
  partCreated: 'Parte Creata',
  partData: 'Dati',
  partDebouncerEmailQueueJob: 'Coda di E-mail',
  partDescription: 'Descrizione della parte',
  partEquipmentVerificationBanner: 'Banner di verifica parti di apparecchiature',
  partLabel: 'Parte | Parti',
  partLevelDetails: 'Prezzo Articolo, Ordinabile/Disponibile, Traduzioni Aggiuntive, Etichette Articolo',
  partName: 'Nome della Parte',
  partNumber: 'Numero della Parte',
  partNumberCopied: '{label} copiato negli Appunti',
  partNumberDescription: 'Il numero della parte interno che gli utenti finali vogliono cercare',
  partNumberSupercededBy: '{partNumber} esiste come tag SupersededPartNumber in...',
  partNumberVisible: 'Numero della Parte Visibile',
  partNumberVisibleDescription: 'Il numero della parte è visibile agli utenti finali',
  partNumberVisibleLocal: 'Visibile su questa pagina',
  partNumberVisibleLocalBlocked: 'Il Numero della Parte non è Visibile Globalmente',
  partOrderable: 'Parte Ordinabile',
  partRequired: 'È necessaria almeno una parte',
  partTag: 'Tag Parte | Tag Parte',
  partTagProperty: 'Proprietà Tag Parte | Proprietà Tag Parte',
  partUpdated: 'Articolo Aggiornato',
  partVerificationInstructions: 'Verifica che questa parte sia adatta alla propria apparecchiatura',
  partialSupport: 'Supporto Parziale',
  partnerApiKey: 'Chiave API partner',
  partnerRESTRequestLimit: 'Limite della richiesta REST partner',
  partsBook: 'Libro Parti | Libri Parti',
  partsBulkImport: {
    description: 'Caricare il file di dati per avviare il processo di importazione delle parti in blocco. Formato file supportato: XLSX.',
    downloadTemplate: 'Scarica il modello XLSX',
    downloadUnprocessedRows: 'Scarica il foglio di calcolo con le righe non elaborate',
    hideRequirements: 'Nascondi i requisiti XLSX',
    overwriteTagValues: 'Sovrascrivi i valori dei tag per i tag corrispondenti',
    overwriteTranslations: 'Sovrascrivi le traduzioni corrispondenti',
    requirements: {
      discountPrice: {
        description: 'Imposta il prezzo scontato a livello di tenant.'
      },
      enUSDescription: {
        description: 'Descrizione del ricambio tradotta nella lingua selezionata. Consulta la nostra <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Guida al supporto multilingue</a>.'
      },
      enUSName: {
        description: 'Nome del ricambio tradotto nella lingua selezionata. Per i nuovi ricambi è richiesta almeno una traduzione. Consulta la nostra <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Guida al supporto multilingue</a>.'
      },
      orderable: {
        description: 'Determina se il ricambio può essere ordinato. Valori consentiti `vero` o `falso`. Il valore predefinito è `vero`.'
      },
      orgDiscountPrice: {
        description: 'Imposta il prezzo scontato a livello di organizzazione per l\'organizzazione specificata. Esempio di intestazione: `<OrganizationName> / Discount Price`'
      },
      orgRetailPrice: {
        description: 'Imposta il prezzo al dettaglio a livello di organizzazione per l\'organizzazione specificata. Esempio di intestazione: `<OrganizationName> / Retail Price`'
      },
      orgWholesalePrice: {
        description: 'Imposta il prezzo all\'ingrosso a livello di organizzazione per l\'organizzazione specificata. Esempio di intestazione: `<OrganizationName> / Wholesale Price`'
      },
      partNumber: {
        description: 'Identificatore univoco del ricambio.'
      },
      retailPrice: {
        description: 'Imposta il prezzo al dettaglio a livello di tenant.'
      },
      supplier: {
        description: 'Nome del fornitore del ricambio.'
      },
      tagInternalName: {
        description: 'Assegna tag al ricambio. L\'intestazione deve corrispondere al nome interno del tag. Per valori multipli, utilizzare il separatore &#124;. Esempio: Rosso&#124;Verde&#124;Blu.'
      },
      thumbnail: {
        description: 'Nome file della miniatura. Estensioni consentite: .png, .jpg, .jpeg, .gif'
      },
      uom: {
        description: 'Unità di misura (ad es. "cad.",", "unità").'
      },
      visible: {
        description: 'Determina se il ricambio è visibile. Valori consentiti `vero` o `falso`. Il valore predefinito è `vero`.'
      },
      wholesalePrice: {
        description: 'Imposta il prezzo all\'ingrosso a livello di tenant.'
      }
    },
    showRequirements: 'Mostra i requisiti XLSX',
    submitNote: 'Facendo clic su “Conferma” si avvia un processo in background e si accede alla pagina “Gestore del processo”.',
    success: 'Processo di importazione delle parti in blocco creato',
    title: 'Importazione delle parti in blocco'
  },
  partsColumns: 'Colonne Parti',
  partsDisplay: 'Visualizzazione parti',
  partsList: 'Elenco Parti',
  partsListColumn: 'Colonna Elenco delle Parti | Colonne Elenco delle Parti',
  partsListData: 'Dati Elenco delle Parti',
  partsListGridHeader: 'Intestazione Griglia Elenco Parti',
  partsNotSelected: 'Immagine predefinita utilizzata per anteprima delle parti. Se non viene applicata un’anteprima personalizzata, Documoto visualizza un’anteprima standard predefinita',
  partsPage: 'Pagina Parti | Pagine Parti',
  partsPageGroup: {
    columnsLoadErrorMsg: 'Caricamento delle parti non riuscito',
    columnsUpdateErrorMsg: 'Si è verificato un errore durante il tentativo di aggiornamento delle Colonne Parti',
    columnsUpdateSuccessMsg: 'Colonne Parti aggiornate',
    cropWhitespaceOnImages: 'Ritaglia lo spazio bianco nelle immagini',
    excludePartCodesFromPartsLists: 'Escludi Codici Parti dagli Elenchi delle Parti',
    highlightAlternateRows: 'Evidenzia Righe Alternate',
    keepBOMOnRight: 'Tieni il BOM sulla Destra',
    keepImagesOnLeft: 'Tieni le Immagini sulla Sinistra',
    printBorderAroundImages: 'Stampa Bordi Intorno alle Immagini',
    printHotpointsOnImages: 'Stampa Hotpoint su Immagini',
    rotateImagesAutomatically: 'Ruota Immagini Automaticamente'
  },
  partsPages: 'Pagine delle Parti',
  password: 'Password',
  passwordBlankMessage: 'La password non può essere vuota',
  passwordCannotBeSame: 'Non deve essere uguale alla password corrente',
  passwordCasingMassage: 'Deve contenere almeno un carattere minuscolo e uno maiuscolo',
  passwordCriteriaInfo: 'La nuova password deve soddisfare i seguenti requisiti:',
  passwordExpiredHeader: 'Password scaduta',
  passwordExpiredInfo: 'La sua password è scaduta. La nuova password deve soddisfare i seguenti requisiti:',
  passwordLowerCaseMessage: 'La password deve contenere almeno un carattere minuscolo',
  passwordMinLengthMessage: 'Le password devono essere lunghe almeno 8 caratteri',
  passwordNotMatchingMessage: 'Le password non sono uguali',
  passwordOptions: 'Opzioni Password',
  passwordOptionsRequired: 'Il campo Opzioni Password non può essere vuoto',
  passwordSpecialCharactersMessage: 'La password deve contenere almeno un carattere speciale',
  passwordUpperCaseMessage: 'La password deve contenere almeno un carattere maiuscolo',
  passwordWillExpire1Day: 'La password di accesso scadrà fra meno di 1 giorno',
  passwordWillExpire5Days: 'La password di accesso scadrà fra meno di 5 giorni',
  passwordsMatch: 'Corrispondenza Password',
  pdfImport: {
    aiPdfImports: 'Importazioni PDF con IA',
    aiPdfImportsDescription: 'Gestisci le importazioni PDF con IA per l\'elaborazione automatizzata dei contenuti.',
    createImport: 'Nuova importazione PDF con IA',
    createImportDescription: 'Seleziona un file PDF di origine e configura le impostazioni di estrazione. Limiti del file: dimensione massima di 500 MB e massimo 3000 pagine.',
    defaultPartNumberCode: 'Codice ricambio predefinito',
    defaultTranslationLocale: 'Lingua di traduzione predefinita',
    defaultUomHelpText: 'Utilizzato quando una colonna dell\'Unità di misura non è mappata o quando una riga BOM estratta non contiene un valore UdM.',
    defaultUomRequired: 'Obbligatoria se non viene fornito un valore UdM',
    dropFileMessage: 'Trascina qui il file oppure clicca per caricarlo',
    fileSizeError: 'La dimensione del file supera il limite di 500 MB',
    importCreatedError: 'Creazione dell\'importazione non riuscita',
    importCreatedSuccess: 'Importazione creata correttamente e aggiunta alla coda di elaborazione',
    mapColumnToTag: 'Associa la colonna al tag Ricambio della pagina',
    monthlyLimitExceeded: 'Il limite mensile di pagine per le importazioni PDF con IA verrebbe superato. Contatta il tuo Customer Success Manager per assistenza.',
    pageNumberFilterInvalidRange: 'Intervallo numeri di pagina non valido',
    pageNumberFilterPlaceholder: 'ad es. 6, -7, 8-, 9-20',
    partNumberCodeHelp: 'Il codice ricambio viene applicato alle righe BOM in cui il valore del numero ricambio è vuoto',
    pdfImport: 'Importazione PDF | Importazioni PDF',
    pdfImportsDescription: 'Gestisci le importazioni PDF con IA per estrarre automaticamente i dati dei ricambi dai documenti PDF',
    publishModalFooterHelp: 'Cliccando su "Pubblica" verrà avviato un processo in background e verrai reindirizzato alla pagina di gestione delle importazioni PDF con IA, dove potrai monitorare lo stato della pubblicazione.',
    publishSkipAutoHotpointing: 'Ignora l\'assegnazione automatica degli hotpoint alle pagine | Ignora l\'assegnazione automatica degli hotpoint alle pagine',
    publishingFinishedNone: 'Pubblicazione dell\'importazione "{importName}" completata. Nessuna pagina è stata pubblicata.',
    publishingFinishedPartial: 'Pubblicazione dell\'importazione "{importName}" completata. {success} pagina pubblicata, {failed} pagina non pubblicata. | Pubblicazione dell\'importazione {importName} completata. {success} pagine pubblicate, {failed} pagine non pubblicate.',
    publishingFinishedSuccess: 'Pubblicazione dell\'importazione "{importName}" completata. {count} pagina pubblicata. | Pubblicazione dell\'importazione {importName} completata. {count} pagine pubblicate.',
    reviewStatusAll: 'Stato: Tutti',
    reviewStatusApproved: 'Approvato',
    reviewStatusDropped: 'Scartato',
    reviewStatusNoStatus: 'Nessuno stato',
    reviewStatusNone: 'Nessuno',
    reviewStatusPending: 'In sospeso',
    selectPagePartTag: 'Seleziona tag ricambio della pagina',
    statusDeclined: 'Rifiutato',
    statusFailed: 'Non riuscito',
    statusPending: 'In sospeso',
    statusProcessing: 'Elaborazione in corso',
    statusPublished: 'Pubblicato',
    statusPublishing: 'Pubblicazione in corso',
    submitNote: 'Cliccando su "Invia" verrà avviato un processo in background e verrai reindirizzato alla pagina di gestione delle importazioni PDF con IA, dove potrai monitorare lo stato dell\'importazione.'
  },
  pdfImportBom: {
    columnMatchStatus: 'Stato corrispondenza',
    columnPagePartTag: 'Tag ricambio della pagina',
    columnPartNameWithLocale: 'Nome del ricambio ({locale})',
    emptyState: 'Nessun elemento BOM trovato',
    existingPartNameApplied: 'Dati del ricambio esistente applicati',
    title: 'Distinta base'
  },
  pdfImportIllustrations: {
    adjustBoundsButton: 'Regola i limiti dell\'illustrazione',
    boundsAdjusted: 'Limiti aggiornati',
    emptyState: 'Nessuna illustrazione per questa pagina.',
    hiresUnavailableError: 'L\'immagine ad alta risoluzione non è disponibile per questa pagina.'
  },
  pdfImportOverview: {
    actionApproveSelected: 'Approva elementi selezionati ({count})',
    actionClearStatusSelected: 'Cancella lo stato degli elementi selezionati ({count})',
    actionCopySelected: 'Unisci alla prima pagina selezionata',
    actionDeleteImport: 'Elimina l\'importazione PDF con IA',
    actionDropSelected: 'Scarta elementi selezionati ({count})',
    actionPendingSelected: 'Imposta elementi selezionati come In sospeso ({count})',
    actionPublishSelected: 'Pubblica elementi selezionati',
    autoMergeAction: 'Unisci automaticamente le pagine',
    autoMergeConfirmHelp: 'L\'unione automatica delle pagine individua le pagine con lo stesso nome e unisce ogni gruppo corrispondente alla prima pagina nell\'ordine di visualizzazione. Le pagine di origine unite a una pagina di destinazione saranno contrassegnate come scartate. Verifica i risultati prima della pubblicazione.',
    autoMergeConfirmTitle: 'Unire automaticamente le pagine con lo stesso nome?',
    autoMergeFailed: 'Unione automatica non riuscita. Non è stata apportata nessuna modifica',
    autoMergeSuccess: 'Unione automatica completata: {count} gruppo/i unito/i, {dropped} pagina/e scartata/e',
    composedPageIndicator: 'Questa pagina contiene contenuti copiati da altre pagine PDF.',
    contentTypeAll: 'Tutti i tipi di contenuto',
    contentTypeBomOnly: 'Solo BOM',
    contentTypeBoth: 'BOM e illustrazioni',
    contentTypeEmpty: 'Pagine vuote',
    contentTypeFilterLabel: 'Tipo di contenuto',
    contentTypeIllustrationsOnly: 'Solo illustrazioni',
    importSettings: 'Impostazioni di importazione',
    includeDroppedPagesLabel: 'Includi le pagine scartate',
    incompleteBomFilterLabel: 'Mostra le pagine con BOM incompleta',
    mergeConfirmSourcePages: '{count} pagina di origine selezionata: | {count} pagine di origine selezionate:',
    mergeConfirmTitle: 'Unire le pagine selezionate alla prima pagina selezionata?',
    mergeConfirmTarget: 'Pagina di destinazione: {pageLabel}',
    mergeFailed: 'Impossibile unire le pagine alla prima pagina selezionata',
    mergeSuccess: 'Pagine unite a {pageLabel} ({bomCount} elementi BOM, {illustrationCount} illustrazioni)',
    noPages: 'Nessuna pagina disponibile',
    noPagesHint: 'Questa importazione non contiene pagine',
    noResults: 'Nessuna pagina corrispondente trovata',
    noResultsHint: 'Prova a modificare i criteri di ricerca o i filtri',
    notificationLoadFailed: 'Impossibile caricare la panoramica',
    notificationReviewStatusUpdated: '{count} pagina/e aggiornata/e con successo',
    notificationSelectAllFailed: 'Impossibile selezionare tutte le pagine',
    notificationUpdateReviewStatusFailed: 'Impossibile aggiornare lo stato della revisione',
    publishBookIdentifierNotUnique: 'L\'identificatore del manuale deve essere univoco.',
    publishBookIdentifierTakenHelp: 'Esiste già un manuale con questo identificatore.',
    publishFailed: 'Impossibile pubblicare la/e pagina/e selezionata/e',
    publishModalTitle: 'Pubblica pagine selezionate',
    publishNewBookHelpText: 'Le pagine pubblicate correttamente verranno aggiunte al nuovo manuale nello stesso ordine in cui compaiono nella panoramica delle importazioni PDF con IA. Verrà creato un nuovo manuale solo se almeno una delle pagine selezionate verrà pubblicata correttamente.',
    publishNewBookIdentifierLabel: 'Identificatore del manuale',
    publishOptionNewBook: 'Crea un nuovo manuale e aggiungi le pagine',
    publishOptionPagesOnly: 'Pubblica solo le pagine',
    reviewManagement: 'Gestione della revisione',
    reviewManagementTooltip: 'Utilizza gli stati di revisione per organizzare il lavoro durante la revisione dei contenuti estratti. Gli stati Approvato, In sospeso e Scartato non influiscono sulla pubblicazione. Servono esclusivamente per monitorare l\'avanzamento della revisione.',
    reviewProgress: 'Avanzamento della revisione',
    title: 'Panoramica'
  },
  pdfImportPageDetails: {
    actionPublish: 'Pubblica pagina',
    firstPage: 'Prima pagina',
    lastPage: 'Ultima pagina',
    matchingPageNewPage: 'Nuova Pagina ricambi',
    matchingPageNewPageSharedSvg: 'Nuova Pagina ricambi, ma con file SVG condiviso con altre pagine',
    matchingPageOpenExisting: 'Apri pagina esistente',
    matchingPageOverwrite: 'La Pagina ricambi esistente verrà sovrascritta',
    navLabel: 'Panoramica delle importazioni PDF con IA',
    navigationFailedText: 'Impossibile accedere alla pagina {pageNumber}',
    nextPage: 'Pagina successiva',
    notificationLoadFailed: 'Impossibile caricare la pagina',
    notificationPublishFailed: 'Impossibile avviare il processo di pubblicazione',
    notificationSaveFailed: 'Impossibile salvare la pagina',
    notificationSaveSuccess: 'Pagina salvata correttamente',
    pageOriginComposed: 'Composta da più pagine PDF',
    pageOriginExtracted: 'Estratta da una singola pagina PDF',
    pageOriginLabel: 'Origine della pagina',
    previousPage: 'Pagina precedente',
    publishPageModalHelpText: 'Questa Pagina ricambi verrà pubblicata al di fuori del contesto di un manuale. La pubblicazione creerà una nuova Pagina ricambi oppure sovrascriverà una pagina esistente in base alle regole di identificazione delle pagine.',
    thumbnailCardTitle: 'Miniatura della pagina PDF',
    viewBom: 'Distinta base'
  },
  pdfImportPublishingHistory: {
    bookResultCreated: 'Creata',
    columnPdfPage: 'Pagine PDF',
    columnPublishingStatus: 'Stato della pubblicazione',
    detailLoadFailed: 'Impossibile caricare i dettagli del processo di pubblicazione',
    emptyBookOperations: 'In questo processo non è stata eseguita alcuna operazione sul manuale.',
    emptyJobsHint: 'L\'attività di pubblicazione verrà visualizzata qui dopo la pubblicazione delle pagine.',
    emptyJobsTitle: 'Non è stato ancora eseguito alcun processo di pubblicazione per questa importazione PDF con IA.',
    emptyPagesTitle: 'Nessuna pagina corrisponde al filtro selezionato.',
    filterAllPages: 'Mostra Tutte le pagine',
    filterFailedOnly: 'Mostra solo le Pagine non pubblicate',
    filterNameQuery: 'Nome o file pagina',
    filterPublishedOnly: 'Mostra solo le Pagine pubblicate',
    helpText: 'Questa pagina mostra la cronologia delle pagine ricambi pubblicate da questa importazione PDF con IA, incluse le pagine create, sovrascritte o la cui pubblicazione non è riuscita.',
    jobLabel: 'Processo n. {number}',
    loadFailed: 'Impossibile caricare la cronologia di pubblicazione',
    resultPublishedCreated: 'Pubblicato - Creato',
    resultPublishedUpdated: 'Pubblicato - Sovrascritto',
    resultSummaryBookCreated: 'È stato creato un nuovo manuale.',
    resultSummaryNone: 'Nessuna pagina pubblicata.',
    resultSummaryPagesFailed: '{n} pagina non pubblicata. | {n} pagine non pubblicate.',
    resultSummaryPagesPublished: '{n} pagina pubblicata. | {n} pagine pubblicate.',
    statusFailed: 'Non riuscita',
    statusInProgress: 'In corso',
    title: 'Cronologia di pubblicazione'
  },
  permission: 'Permesso | Permessi',
  phoneNumber: 'Numero di Telefono',
  phoneNumberExt: 'Est.',
  phonePrimary: 'Numero di Telefono Primario',
  phoneSecondary: 'Numero di Telefono Secondario',
  pinFilter: 'Aggiungi il filtro alla pagina dei risultati della ricerca',
  pinned: 'Bloccato',
  plusMoreOrgs: '+ {totalOrgCount} Organizzazioni aggiuntive',
  polishDescription: 'Descrizione in Polacco',
  polishName: 'Nome in Polacco',
  populatePdfNameSelection: 'Compila selezione nome file PDF',
  populatePdfNameWith: 'Compila nome file PDF con',
  port: 'Porta',
  portrait: 'Ritratto',
  portugueseDescription: 'Descrizione in Portoghese',
  portugueseName: 'Nome in Portoghese',
  postComment: 'Pubblica Commento',
  postalCode: 'Codice Postale',
  poweredBy: 'Sviluppato da',
  preferences: 'Preferenze',
  preferencesDisable: 'Disabilita le Preferenze Utente',
  prefix: 'Prefisso | Prefissi',
  preview: 'Anteprima',
  previewOfName: 'Anteprima di {name}',
  pricing: 'Prezzo',
  pricingDiscountEnabled: 'Visualizza il Prezzo Scontato',
  pricingDisplayInCart: 'Visualizza i Prezzi nel Carrello',
  pricingDisplayInPartsList: 'Visualizza i Prezzi nell’Elenco Parti',
  pricingGlobal: 'Prezzo Globale',
  pricingGlobalDescription: 'Il prezzo normale quando non viene sovrascritta alcuna Organizzazione',
  pricingHideInitially: 'Nascondi il prezzo inizialmente',
  pricingHidePricingButton: 'Attiva il Pulsante Nascondi il Prezzo',
  pricingHidePricingButtonDisable: 'Disabilita il Pulsante Nascondi il Prezzo',
  pricingHidePricingButtonDisableHelp: 'Disabilitando il pulsante "Nascondi il prezzo", gli utenti non potranno più mostrare o nascondere i livelli di prezzo. Tutti i livelli di prezzo configurati con "Nascondi il prezzo inizialmente" rimarranno nascosti e gli utenti non potranno visualizzarli.',
  pricingOrganization: 'Prezzo dell’Organizzazione',
  pricingOrganizationDeleteConfirm: 'Sei sicuro di voler eliminare questo prezzo dell’Organizzazione?',
  pricingOrganizationDescription: 'Il prezzo dell’organizzazione sovrascrive il prezzo globale per tutti gli utenti all’interno di un’Organizzazione e delle sue Organizzazioni figlie.',
  pricingOrganizationDuplicate: 'Questa organizzazione è già stata sovrascritta',
  pricingOrganizationEmptyState: 'Nessuna sovrascrittura di organizzazione definita. Cliccare {add} per iniziare.',
  pricingRetailEnabled: 'Visualizza il Prezzo Al Dettaglio',
  pricingWholesaleEnabled: 'Visualizza il Prezzo All’Ingrosso',
  primary: 'Primario',
  print: 'Stampa',
  printJob: 'Lavoro di Stampa',
  printLogo: 'Logo Stampa',
  printSetting: 'Impostazione di Stampa',
  printSettingCopyMessage: 'Inserire un nome unico per la nuova Impostazione di Stampa.',
  printSettingCreated: 'Impostazione di Stampa creata',
  printSettingDeleteFail: 'Cancellazione dell’Impostazione di Stampa Non Riuscita',
  printSettingEmptyMessage: 'Nessuna Impostazione di Stampa definita. Aggiungi un’Impostazione di Stampa per iniziare.',
  printSettingSaveFail: 'Salvataggio dell’Impostazione di Stampa Non Riuscito',
  printSettingSelectionRequired: 'È necessario selezionare un’impostazione di stampa.',
  printSettingSetDefaultSuccess: 'Set Impostazione di Stampa Predefinita',
  printSettingUpdateFail: 'Aggiornamento dell’Impostazione di Stampa Non Riuscito',
  printSettings: 'Impostazioni di Stampa',
  printSettingsLogo: 'Logo Impostazioni di Stampa',
  printerLane: 'Lane della stampante',
  printing: 'Stampa',
  printingDisabled: 'Disabilita Tutta la Stampa',
  privacyPolicy: 'Normativa sulla Privacy',
  proceed: 'Prosegui',
  process: 'Elaborazione',
  processContent: 'Elaborazione del Contenuto',
  processToDraft: 'Elaborazione in bozza',
  processedPlzToDraft: 'PLZ elaborati in bozza',
  processing: 'Elaborazione in corso',
  productCategory: 'Categoria di prodotti | Categorie di prodotti',
  productCategoryName: 'Nome Categoria di prodotti',
  productId: 'ID prodotto',
  productIdErrorMessage: 'L’ID prodotto è obbligatorio',
  productIdMessage: 'Il valore identificativo che gli utenti utilizzeranno per trovare il prodotto, ad esempio “FTX1000”',
  productPage: 'Pagina prodotto | Pagine prodotto',
  productPageAccessControlDescription: 'I controlli degli accessi definiscono chi può visualizzare questa pagina, in base alle Organizzazioni e al Gruppo Utente assegnati.',
  productPageCreated: 'Pagina prodotto creata',
  productPageDescription: 'Descrizione della pagina prodotto',
  productPageIdentifierMessage: 'Identificatore interno univoco di questa pagina',
  productPageName: 'Nome Pagina prodotto',
  productPageProductId: 'ID prodotto Pagina prodotto',
  productPageUpdated: 'Pagina prodotto aggiornata',
  productPagesBulkImport: {
    description: 'Carica il file dei dati per avviare l\'importazione in blocco delle pagine prodotto. Formato file supportato: XLSX.',
    downloadUnprocessedRows: 'Scarica il foglio di calcolo con le righe non elaborate',
    overwriteAccessControls: 'Sovrascrivi i controlli degli accessi (organizzazioni e gruppi utenti)',
    overwriteAssociatedMedia: 'Sovrascrivi i contenuti multimediali associati',
    requirements: {
      enUSCategory: {
        description: 'Nome della categoria prodotto esistente per una determinata lingua. Consulta la nostra <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Guida al supporto multilingue</a>.'
      },
      enUSDescription: {
        description: 'Descrizione della pagina prodotto tradotta nella lingua selezionata. Consulta la nostra <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Guida al supporto multilingue</a>.'
      },
      enUSName: {
        description: 'Nome della pagina prodotto tradotto nella lingua selezionata. Per le nuove pagine prodotto è richiesta almeno una traduzione. Consulta la nostra <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Guida al supporto multilingue</a>.'
      },
      identifier: {
        description: 'Identificatore univoco della pagina prodotto, visibile e ricercabile solo nell\'Admin Center.'
      },
      media: {
        description: 'Elenco degli identificatori dei contenuti multimediali associati a una determinata pagina prodotto. Per valori multipli, utilizzare il separatore &#124;.'
      },
      organizations: {
        description: 'Elenco delle organizzazioni autorizzate ad accedere a una determinata pagina prodotto. Per valori multipli, utilizzare il separatore &#124;.'
      },
      productId: {
        description: 'Identificatore della pagina prodotto per gli utenti finali, visibile e ricercabile nella Libreria. L\'ID prodotto non deve necessariamente essere un valore univoco.'
      },
      tagInternalName: {
        description: 'Assegna tag alla pagina prodotto. L\'intestazione deve corrispondere al nome interno del tag. Per valori multipli, utilizzare il separatore &#124;. Esempio: Rosso &#124; Verde &#124; Blu.'
      },
      thumbnail: {
        description: 'Nome file della miniatura. Estensioni consentite: .png, .jpg, .jpeg, .gif'
      },
      userGroups: {
        description: 'Elenco dei gruppi utenti autorizzati ad accedere a una determinata pagina prodotto. Per valori multipli, utilizzare il separatore &#124;.'
      }
    },
    success: 'Processo di importazione in blocco delle pagine prodotto creato',
    title: 'Importazione in blocco delle pagine prodotto'
  },
  production: 'Produzione',
  professional: 'Professionale',
  profile: 'Profilo',
  prohibitExportDownloadOfContent: 'Vieta Esportare/Scaricare contenuto',
  prohibitExportDownloadOfContentHelpText: 'Impostando \'Attiva\' si impedirà agli utenti (con privilegi) di esportare o scaricare questo contenuto.',
  property: 'Proprietà | Proprietà',
  province: 'Provincia',
  'public': 'Pubblico',
  publish: 'Pubblica',
  publishDocuments: 'Pubblica Documenti',
  publishDraft: 'Pubblica Bozza',
  publishThumbnailJob: 'Pubblica Anteprima',
  publisher: 'Editore | Editori',
  publisherJob: 'Lavoro di Pubblicazione',
  publisherLane: 'Lane dell’editore',
  publisherManualLane: 'Lane del Manuale dell’editore',
  publisherMessage: 'Creazione di contenuto, gestione e  impostazioni di stampa',
  publishingErrors: 'Errori di pubblicazione',
  publishingErrorsWithName: 'Pubblicazione degli Errori {name}',
  publishingInProgress: 'Pubblicazione in corso, impossibile inviare',
  purchaseOrder: 'Ordine d’Acquisto',
  purchaseOrderTemplateDisabled: 'Disabilita i Modelli d’Ordine',
  purchaseOrderTemplateEnabled: 'Attiva i Modelli d’Ordine',
  qty: 'Q.tà',
  quantity: 'Quantità',
  query: 'Query',
  quickAdd: 'Aggiunta Rapida',
  quickAddHelpText: 'Inizia a digitare per trovare parti da aggiungere al carrello.',
  quickAddInCartEnabled: 'Attiva Aggiunta rapida nel Carrello',
  quickLinks: 'Link Veloci',
  quote: 'Preventivo | Preventivi',
  quoteFormType: 'Modulo di Preventivo',
  quoteTemplateDisabled: 'Disabilita i Modelli di Preventivo',
  quoteTemplateEnabled: 'Attiva i Modelli Preventivo',
  range: 'Scelta',
  rearrange: 'Riordinare',
  rebuildIndexJob: 'Ricrea Indice',
  recentSearches: 'Ricerche recenti',
  recentlyAdded: 'Elementi Aggiunti Di Recente',
  recentlyEdited: 'Elementi Modificati Di Recente',
  recentlyViewed: 'Elementi Visualizzati Di Recente',
  recipientOrRecipients: 'Destinatari',
  rectangle: 'Rettangolo',
  redirect: 'Reindirizzare',
  refresh: 'Aggiorna',
  related: 'Correlato',
  relatedDescription: 'Medium correlato già esistente nella libreria a questo {type}. Nota: il relativo medium deve avere i controlli degli accessi applicati perché gli utenti possano vederlo nella scheda \'Correlato\'.',
  relatedInfo: 'Elementi Correlati',
  relatedView: 'Vedi Medium Correlato',
  relationship: 'Relazione | Relazioni',
  releaseNotes: 'Note di Rilascio',
  remainingWidth: 'Larghezza Rimanente',
  rememberMe: 'Ricordami',
  remove: 'Rimuovi',
  removeAll: 'Rimuovi Tutto',
  removeItemConfirmation: 'Sei sicuro di voler eliminare {item}?',
  removeItemCount: 'Sei sicuro di voler eliminare {count} {type}?',
  replace: 'Sostituisci',
  replaceExisting: 'Sostituisci Esistente',
  report: 'Resoconto | Resoconti',
  reportAnIssue: 'Riporta un Problema',
  reportAnIssueMessage: 'E-mail inviata correttamente.',
  reportCatalogName: 'Nome Catalogo Report',
  reportCatalogNotSet: 'Il catalogo dei report non è stato definito per il report.',
  reportDefinition: 'Definizione Report| Definizioni Report',
  reportDefinitionDeleteError: 'La definizione del report non è stata cancellata',
  reportExportTimeWarning: 'A seconda del numero di record e del formato selezionato, l’esportazione può richiedere alcuni minuti.',
  reportSettings: 'Impostazioni di Report',
  reporting: 'Resoconti',
  reportingMessage: 'Accesso a vari resoconti e metriche',
  reportsEmptyState: 'Nessun Report',
  reportsLibrary: 'Libreria di Report',
  requestForQuote: 'Richiesta di Preventivo',
  requestFormType: 'Modulo di Preventivo',
  requireAuthentication: 'Richiede l’Autenticazione',
  required: 'Richiesto',
  requiredField: 'Campo Richiesto',
  requiredItem: 'È richiesto {item}.',
  requiredMessage: 'È richiesto un {item}.',
  requiredMessageAndUnique: 'Un {item} è obbligatorio e deve essere unico.',
  requiredReading: 'Lettura Richiesta',
  requiredReadingMessage: 'Revisionare quanto segue:',
  requiredType: 'È richiesto un tipo.',
  requiredUrlMessage: 'È richiesto un formato URL corretto.',
  reset: 'Reimposta',
  resetPassword: 'Reimposta la Password',
  resetPasswordError: 'Si è verificato un problema durante la reimpostazione della password, riprovare.',
  resetPasswordTokenError: 'Il token di reimpostazione della password non è valido.',
  resetZoom: 'Azzera Zoom',
  resize: 'Ridimensiona',
  resizeThumbnails: 'Ridimensiona automaticamente anteprime',
  resource: 'Risorsa | Risorse',
  result: 'Risultato | Risultati',
  resultFor: 'Risultato per {item} | Risultati per {item}',
  retail: 'Vendita Al Dettaglio',
  retailPrice: 'Prezzo Al Dettaglio',
  retailTotal: 'Totale della Vendita Al Dettaglio',
  'return': 'Ritorna',
  returnToItem: 'Ritorna a {item}',
  returnToMedia: 'Ritorna a Media',
  returnToPartList: 'Ritorna all’Elenco Parti',
  returnToTemplate: 'Ritorna a Modello',
  returnToViewer: 'Torna al visualizzatore',
  revert: 'Annulla',
  revertChanges: 'Annullare le Modifiche',
  revertChangesMsg: 'Sei sicuro di voler annullare le modifiche?',
  right: 'Destra',
  romanianDescription: 'Descrizione in Romeno',
  romanianName: 'Nome in Romeno',
  rootLevelBrowseFlow: 'Livello Radice',
  row: 'Riga',
  russianDescription: 'Descrizione in Russo',
  russianName: 'Nome in Russo',
  s3DataExportsEnabled: 'Attiva l’esportazione dei dati S3',
  sampleData: 'Dati Campione',
  samplePreview: 'Anteprima Esemplificativa',
  sandbox: 'Sandbox',
  sat: 'Sab',
  save: 'Salva',
  saveAndClose: 'Salva e chiudi',
  saveAndEditTarget: 'Salva e modifica destinazione',
  saveChanges: 'Salvare le modifiche a {item}? {name}',
  saveChangesToItem: 'Salvare le modifiche a questo {item}?',
  saveNewAPIKey: 'Nuova Chiave di Integrazione non Salvata, selezionare Ritorna per completare la configurazione',
  saveNewWidgetKey: 'Nuova chiave widget non salvata. Torna per completare la configurazione.',
  saveOrderAttachmentsError: 'Impossibile salvare gli allegati dell\'ordine.',
  saved: 'Salvato',
  search: 'Cerca',
  searchAllContent: 'Ricerca in tutti i contenuti',
  searchCategories: 'Categorie',
  searchConfiguration: 'Ricerca configurazione',
  searchContent: 'Cerca {content}',
  searchCriteria: 'Criterio di Ricerca',
  searchDocumoto: 'Cerca Documoto',
  searchFeatures: 'Ricerca funzioni',
  searchFieldConfigDescription: 'Le seguenti impostazioni di ricerca del campo del sistema si applicano solo alla ricerca generale della Libreria, alla pagina dei risultati di ricerca e all’aggiunta rapida nel Carrello. Altre funzioni di ricerca (come la ricerca Centro amministratore e Libreria dove usata) non saranno interessate.',
  searchInContent: 'Ricerca in {contentName}...',
  searchPlaceholder: 'Ricerca in tutti i contenuti...',
  searchPrompt: 'Ricerca in tutti i contenuti...',
  searchProperty: 'Cerca la Proprietà | Cerca le Proprietà',
  searchResults: 'Risultati della ricerca',
  searchResultsConfiguration: 'Configurazione dei risultati di ricerca',
  searchSettings: 'Impostazioni di ricerca',
  searchSettingsDescription: 'Queste impostazioni controllano diversi comportamenti, funzioni e risultati di ricerca della Libreria.',
  searchTerm: 'Termine di Ricerca',
  searchTips: 'Suggerimenti per la ricerca:',
  searchType: 'Tipo',
  searchable: 'Consultabile',
  searchableFieldsSuccessfullyUpdated: 'Campi ricercabili aggiornati correttamente.',
  searchableTag: 'Tag Consultabile',
  searchingInLanguage: 'Ricerca solo in {lang}',
  searchingInTwoLanguages: 'Ricerca solo in {lang1} e {lang2}',
  section: 'Sezione',
  select: 'Seleziona',
  selectAField: 'Seleziona un {field}',
  selectAll: 'Seleziona Tutto',
  selectAndClose: 'Selezionare e Chiudere',
  selectChapters: 'Seleziona Capitolo/i',
  selectChildren: 'Seleziona Figli',
  selectFields: 'Seleziona {fields}',
  selectItem: 'Seleziona {item}',
  selectMedia: 'Seleziona Contenuto/i Multimediale/i',
  selectPage: 'Seleziona Pagina',
  selectPages: 'Seleziona Pagina/e',
  selectTargetPage: 'Seleziona Pagina Target',
  selected: 'Selezionato',
  selectedTargetPage: 'Pagina Target Selezionata',
  send: 'Invia',
  sendReverificationEmail: 'Invia e-mail di riconferma',
  sendVerificationEmail: 'Invia e-mail di verifica',
  september: 'Settembre',
  sequence: 'Sequenza',
  serbianDescription: 'Descrizione in Serbo',
  serbianName: 'Nome in Serbo',
  serviceUri: 'Assistenza URI',
  sessionLog: 'Registro di Sessione',
  set: 'Imposta',
  setAsDefault: 'Imposta come Predefinito',
  setPassword: 'Imposta password',
  settings: 'Impostazioni',
  settingsMessage: 'Aggiorna la tue preferenze utente e password',
  shape: 'Forma',
  shapeTool: 'Strumento Forma',
  shared: 'Condiviso',
  sharedCart: 'Carrello Condiviso | Carrelli Condivisi',
  sharedCartDeleteContent: 'Questo rimuove il Carrello Condiviso da tutte le Organizzazioni in cui è stato condiviso.',
  sharedCartOrganizationContent: 'Selezionare le Organizzazioni che possono usare questo Carrello Condiviso.',
  sharedShoppingCartsEnabled: 'Abilita Carrelli Condivisi',
  shoppingCartExportJob: 'Esportazione Carrello',
  shoppingCartLoadingLongTime: 'Il carrello è in fase di caricamento. Le icone del carrello diventeranno disponibili quando il processo sarà completo. Se il problema persiste, contattare l’amministratore Documoto per ricevere assistenza.',
  showChapterTOCForHiddenPages: 'Mostra TOC Capitolo per le Pagine Nascoste',
  showExportFromSearch: 'Consenti Esporta da Risultati Ricerca',
  showExportFromSearchHelp: 'Consenti l’esportazione della lista di libri risultante da una ricerca',
  showHelp: 'Mostra Aiuto',
  showIdentifierInLibrary: 'Mostra gli identificatori dei media e della pagina prodotto nella Libreria',
  showIdentifierInSearch: 'Mostra Identificatore media nella ricerca',
  showItem: 'Mostra {item}',
  showLess: 'Mostra Di Meno',
  showMediaDescriptionFilter: 'Mostra il Filtro Descrizione dei Media',
  showMediaIdentifierFilter: 'Mostra il Filtro Identificatore dei Media',
  showMediaNameFilter: 'Mostra il Filtro Nome dei Media',
  showMore: 'Mostra Di Più',
  showOnlyExactMatches: 'Mostra solo corrispondenze esatte',
  showOrganizationFilter: 'Mostra il Filtro dell’Organizzazione',
  showPartNameFilter: 'Mostra il Filtro Nome della Parte',
  showPartNumberFilter: 'Mostra il Filtro Numero della Parte',
  showRecentlyAdded: 'Mostra gli Elementi Aggiunti Di Recente',
  showRecentlyViewed: 'Mostra gli Elementi Visualizzati Di Recente',
  showSearchButton: 'Mostra il Pulsante di Ricerca sulla Homepage',
  showSearchButtonHelp: 'Mostra il pulsante \'Vai alla Ricerca\' nell’intestazione della Libreria',
  signature: 'Firma',
  size: 'Dimensione',
  snapshot: 'Istantanea | Istantanee',
  solrSlaveSvrOverride: 'Sovrascrittura delle SOLR Slave Servers Base URLs',
  sortAsc: '{value} A-Z',
  sortDesc: '{value} Z-A',
  sortRelevant: 'Più Rilevante',
  sortType: 'Riordina per Tipo',
  sourceBrowseFlow: 'Flusso di navigazione di origine',
  sourceFile: 'File di origine',
  sourceFilename: 'Nome file di origine',
  spanishDescription: 'Descrizione in Spagnolo',
  spanishName: 'Nome in Spagnolo',
  square: 'Quadrato',
  ssoConfiguration: 'Configurazione SSO',
  ssoIdpMetadataUrl: 'URL dei metadati IDP SSO',
  ssoLoginMaxAuthenticationAgeSeconds: 'Durata massima in secondi per l’autenticazione dell’accesso SSO',
  ssoSamlDnAttributeName: 'Nome attributo DN SAML SSO',
  ssoSamlEmailAttributeName: 'Nome attributo Email SAML SSO',
  ssoSamlMemberofAttributeName: 'Nome attributo membro di SAML SSO',
  ssoSniForSsoMetadataRetrieval: 'Utilizza SNI per recuperare i metadati SSO',
  standard: 'Standard',
  standardUserGroup: 'Gruppo utente standard',
  startDate: 'Data Iniziale',
  startDateRequired: 'È richiesta una data di inizio.',
  state: 'Stato',
  'static': 'Statico',
  status: 'Condizione',
  statusCode: 'Codice Stato | Codici Stato',
  stitchPages: 'Pagine dei Punti',
  storeFilterValues: 'Memorizza valori filtro',
  storeFilterValuesDescription: 'L’abilitazione di questa impostazione memorizza i valori impostati dagli utenti nei filtri della pagina di ricerca per questa etichetta.',
  storeFrontAdmin: 'Gestione della Vetrina',
  storefront: 'Vetrina',
  storefrontIntegration: 'Integrazione della Vetrina| Integrazioni della Vetrina',
  storefrontIntegrationSubtitle: 'Queste impostazioni controllano i vari elementi e le opzioni dell’Integrazione della Vetrina. Prestare attenzione durante le modifiche. Contattare l’Assistenza Documoto per ulteriori informazioni.',
  storefrontSettings: 'Impostazioni della Vetrina',
  storefrontSettingsDescription: 'Queste impostazioni controllano i vari elementi e le opzioni della Vetrina. Prestare attenzione durante le modifiche. Contattare i Servizi Documoto per ulteriori informazioni.',
  storefrontSettingsOrgDescription: 'Queste impostazioni controllano i vari elementi e le opzioni della Vetrina a livello dell’Organizzazione. Prestare attenzione durante le modifiche. Contattare i Servizi Documoto per ulteriori informazioni.',
  stroke: 'Traccia',
  style: 'Stile | Stili',
  styles: {
    colorHotpoint: 'Default di Hotpoint',
    inheritedFromOrg: 'Ereditato dall’Organizzazione {org}',
    inheritedFromSystem: 'Ereditato dal Default di Sistema',
    inheritedFromTenant: 'Ereditato dal Tenant',
    invalidHexcode: 'Codice HEX non valido',
    organization: 'Stile dell’Organizzazione | Stili dell’Organizzazione',
    organizationSaved: 'Stili dell’Organizzazione Salvati',
    sampleNavigation: 'Schede di Navigazione',
    samplePrimary: 'Navigazione/Tasti',
    sampleSelectedHotpoint: 'Hotpoint Selezionati',
    tenant: 'Stile del Tenant | Stili del Tenant',
    tenantSaved: 'Stili del Tenant Salvati'
  },
  subChapter: 'Sottocapitolo | Sottocapitoli',
  subject: 'Oggetto',
  subjectMessage: 'È richiesto un Oggetto',
  submit: 'Invia',
  submitPurchaseOrder: 'Ordine d’Acquisto',
  submitRequestForQuote: 'Richiesta di Preventivo',
  submitted: 'Inviato',
  submittedBy: 'Inviato da',
  submittedFilesMessage: 'File {fileCount} Inviati.',
  submitter: 'Mittente',
  submitterEmail: 'E-mail Mittente',
  submitterFirstName: 'Nome Mittente',
  submitterLastName: 'Cognome Mittente',
  submitterOrgName: 'Nome Organizzazione Mittente',
  submitterUserName: 'Nome Utente Mittente',
  success: 'Successo',
  successNotificationDuration: 'Aggiungi al Carrello - Durata della Notifica Toast Riuscita',
  suffix: 'Suffisso | Suffissi',
  suggestedKeywords: 'Parole chiave suggerite',
  suggestedResults: 'Risultati suggeriti',
  suggestion: 'Suggerimento | Suggerimenti',
  sun: 'Dom',
  superAdminSettings: 'Impostazioni Superadmin',
  superadmin: 'Superadmin',
  supersede: 'Sostituisci',
  supersedeComplete: 'Vuoi completare la tua sostituzione?',
  supersedeDiscardChanges: 'Eliminare la tua sostituzione?',
  supersedeMainText: 'La sostituzione sostituisce una parte esistente con una o più parti, in tutte le Pagine delle Parti in cui viene trovata la parte vecchia. Il numero della parte vecchia viene cancellato ma rimane consultabile tramite tag, in modo che il contenuto possa essere trovato usando il vecchio numero o il nuovo numero.',
  supersedeMessage: 'Gli aggiornamenti delle parti hanno effetto immediato. La ricerca rifletterà gli aggiornamenti entro pochi minuti.',
  supersedeNotProcessed: 'La tua sostituzione non verrà processata.',
  supersedeReplacePart: 'Trova una o più parti che sostituiscano la parte',
  supersedeSuccessful: 'Sostituita Correttamente',
  supersedeWith: 'Sostituisci Parte Con...',
  superseded: 'Sostituita',
  supersededParts: 'Parti sostituite',
  supplier: 'Fornitore | Fornitori',
  supplierDescription: 'L’azienda che fornisce questa parte',
  supplierKey: 'Chiave del fornitore',
  supportedDraftArchives: 'File non supportato; file di bozza supportati: MDZ, PLZ',
  supportedImageFormats: 'Formati dell’immagine supportati: GIF, JPG, JPEG, PNG',
  surroundWithQuotes: 'Racchiudi tra virgolette diversi termini di ricerca per una corrispondenza esatta.',
  svgFinder: 'Rilevatore SVG',
  swedishDescription: 'Descrizione in Svedese',
  swedishName: 'Nome in Svedese',
  system: 'Sistema',
  systemAdmin: 'Gestione del Sistema',
  systemFieldSearchAndFiltering: 'Cerca e filtra campo del sistema',
  systemFields: 'Campi del Sistema',
  systemName: 'Nome sistema',
  systemStatus: 'Stato del Sistema',
  systemVersion: 'Versione sistema',
  tabDelimited: 'Delimitato da tabulazione',
  tableOfContents: 'Indice',
  tabloid: 'Tabloid',
  tag: 'Tag | Tag',
  tagDeleteAffectedCount: 'Questo cancellerà il tag e rimuoverà le informazioni del tag da {contare} elementi.',
  tagDeleteAffectedNone: 'Attualmente nessun elemento usa questo tag.',
  tagEditor: {
    filterPrompt: 'Visualizzazione dei primi 100 valori. Usa il filtro per vedere altro.',
    rangeBoundLengthInvalid: 'Il limite non può avere più di {limit} cifre.',
    tagEditorModal: 'Modalità Editore Tag',
    textfieldHelpText: 'Inserisci uno o più valori separati da punto e virgola. Esempio: SN001; SN002'
  },
  tagManagerDeleteWarning: 'Qualunque medium già presente con {deleteCategoryName} perderà questa categoria dopo la cancellazione.',
  tagName: 'Nome etichetta',
  tagSearchAndFiltering: 'Cerca e filtra etichetta',
  tagSearchAndFilteringHelpText: 'Suggerimento: alcune impostazioni relative a ricerca e filtri sono anche configurabili negli editor di etichette Gestione etichette, disponibili qui: ',
  tagSubmitAffected: 'Qualunque contenuto {type} cancellerà automaticamente il tag {tag} oltre alle modifiche.',
  tagValue: 'Valore del Tag | Valori del Tag',
  tagValueMissing: 'È necessario inserire un valore del tag',
  tagValueMultiple: 'Punto e virgola per delimitare in caso di voci multiple',
  tagValueTooLong: 'Il valore del tag supera il limite di 25 caratteri | I valori del tag superano il limite dei 25 caratteri',
  tagsDeleteError: 'Impossibile eliminare uno o più tag',
  tagsDeleteSuccess: 'Tag eliminati correttamente',
  tagsDisplayMore: 'Visualizzazione dei primi 100 valori. Usa il filtro per vedere di più.',
  tagsManager: 'Gestore del Tag',
  tagsSaveError: 'Salvataggio di uno o più tag non riuscito',
  tagsSaveSuccess: 'Tag salvati correttamente',
  tagsUpdateError: 'Aggiornamento di uno o più tag non riuscito',
  tagsUpdateSuccess: 'Tag aggiornati correttamente',
  targetBrowseFlow: 'Flusso di navigazione di destinazione',
  taxon: 'Classificazione',
  taxonomy: 'Classificazione',
  template: 'Modello | Modelli',
  templateEmailRecipients: 'Modello Destinatari E-mail',
  templateLayout: {
    addItem: 'Aggiungi Elemento',
    addRow: 'Aggiungi Riga',
    deleteColumn: 'Elimina Colonna',
    deleteRow: 'Elimina Riga',
    fullWidth: 'Larghezza Intera',
    oneColumn: 'Una Colonna',
    threeColumns: 'Tre Colonne',
    twoColumns: 'Due Colonne'
  },
  tenant: 'Tenant',
  tenantAdmin: 'Gestione del Tenant',
  tenantAdminMessage: 'Impostazioni ampie per i controlli del tenant',
  tenantCleanerJob: 'Manutenzione Tenant',
  tenantConfiguration: 'Configurazione titolare',
  tenantEmailRecipients: 'Tenant Destinatari E-mail',
  tenantEmailRecipientsOverrideMessage: 'Questo verrà sovrascritto se vengono specificati i Destinatari E-mail dell’Organizzazione',
  tenantIndexQueueJob: 'Coda Indice Tenant',
  tenantKey: 'Chiave titolare',
  tenantKeyError: 'La chiave del titolare non è unica',
  tenantKeyMessage: 'La chiave del titolare deve essere unica',
  tenantLabelDeleteMessage: 'L’eliminazione di questa etichetta ripristina il nome Documoto predefinito',
  tenantLabelsPageText: 'Le etichette vengono usate per personalizzare i nomi di molti oggetti che si trovano all’interno della Libreria Documoto e delle schermate Amministrazione.',
  tenantPrintSettingsDescription: 'Scegliere l’impostazione di stampa predefinita per il titolare. Questo verrà utilizzato per tutte le stampe dei libri, salvo sovrascrittura dell’Organizzazione o del Medium.',
  tenantReindexModulus: 'Modulo reindicizzazione titolare',
  tenantSettings: {
    collapseTOCLabel: 'Ridurre TOC nella Pagina Corrispondente',
    defaultLocaleLabel: 'Impostazioni Locali Predefinite',
    defaultLocaleMessage: 'Le impostazioni locali predefinite del proprietario.',
    defaultSupplierLabel: 'Fornitore Predefinito',
    defaultSupplierMessage: 'Il fornitore predefinito del proprietario.',
    deleteMissingTranslationsOnPublishLabel: 'Eliminare traduzioni mancanti su Pubblica?',
    deleteMissingTranslationsOnPublishMessage: 'Attiva per eliminare traduzioni di articoli su Pubblicazione',
    enableChapterIndexingLabel: 'Attiva l‘indicizzazione per i capitoli multimediali',
    enableChapterIndexingMessage: 'Indicizzare i capitoli',
    enableIndexingLabel: 'Indicizza sulla pubblicazione',
    enableIndexingMessage: 'Attiva l’indicizzazione per la pubblicazione.',
    excludePartsFromAccessControlChecksLabel: 'Escludi parti dalle regole di controllo degli accessi',
    excludePartsFromAccessControlChecksMessage: 'Quando questa opzione è abilitata, le parti sono visibili a tutti gli utenti, indipendentemente dai controlli degli accessi ai media.',
    exportPgAsHashLabel: 'Esporta il nome del file pagina come chiave Hash',
    exportPgAsHashMessage: 'Utilizza chiavi Hash di pagina come nomi dei file pagina nel contenuto esportato',
    helpUrlLabel: 'URL Aiuto Predefinito',
    helpUrlMessage: 'L’URL di un sistema di assistenza alternativo.',
    hotPointLinkPageInBookOnlyLabel: 'Collegamenti Hotpoint alla Pagina solo in formato libro',
    hotPointLinkPageInBookOnlyMessage: 'Collegamenti Hotpoint da Pagine solo in formato libro',
    lockPartTrOnPublishLabel: 'Bloccare le traduzioni di articoli su Pubblica',
    lockPartTrOnPublishMessage: 'Impedisce che le traduzioni di articoli vengano modificate durante la Pubblicazione',
    mediaTimestampLabel: 'Aggiornamento Timestamp dei Media su Modifica Controllo degli Accessi',
    mediaTimestampMessage: 'Abilitare questa opzione se una modifica nelle categorie dei supporti di controllo degli accessi deve aggiornare la marca temporale del supporto.',
    publisherDefaultUom: 'UDM Predefinita Editore',
    publishingContactLabel: 'Pubblicazione dell’E-mail Contatto',
    publishingContactMessage: 'L’indirizzo e-mail predefinito che riceverà le e-mail quando viene riportato un problema di contenuto.',
    replaceHotpointLabel: 'Sostituisci Sempre Link Hotpoint nella Pubblicazione',
    replaceHotpointMessage: 'Solo per pubblicazioni Docustudio.',
    ssoLoginSystemLabel: 'Sistema di Login SSO',
    ssoLoginSystemMessage: 'Sistema di Identity Provider per SSO.',
    userPasswordExpirationLabel: 'Giorni rimanenti alla scadenza della password dell’utente',
    userPasswordExpirationMessage: 'Numero di giorni dopo i quali le password devono essere reimpostate; lasciare in bianco per evitare che scadano'
  },
  tenantSettingsSaved: 'Impostazioni Tenant Salvate',
  tenantSettingsSubtitle: 'Le seguenti impostazioni controllano i comportamenti e le proprietà a livello del tenant. Fare attenzione quando si apportano le modifiche. Contattare Documoto Services per ulteriori informazioni.',
  tenantSettingsTitle: 'Impostazioni Tenant',
  tenantSuppliers: 'Fornitori del titolare',
  tenantType: 'Tipo di titolare',
  tenantWebserviceUser: 'Utente Webservice del titolare',
  text: 'Testo',
  textArea: 'Area di Testo',
  textColor: 'Colore testo',
  textField: 'Casella di Testo',
  textFile: 'File di Testo (CSV, TXT)',
  textTool: 'Strumento Testo',
  threeD: {
    addFile: 'Aggiungi il file di una parte 3D',
    beforeSaveModal: {
      message: 'Desideri sostituire questo file ovunque oppure vuoi collegarlo solo a questa parte? Se decidi di sostituire il file, accadrà quanto segue:',
      messageBulletOne: '{count} le parti saranno aggiornate con il nuovo file CAD',
      messageBulletOneForContent: '{count} {contentType} saranno aggiornate con il nuovo file CAD',
      messageBulletTwo: 'La versione precedente del file sarà eliminata dal file system Documoto',
      tip: 'Suggerimento: Per evitare che un file venga sovrascritto durante il processo di collegamento, puoi modificare il nome del file che stai cercando di collegare prima di importarlo.',
      title: 'In Documoto esiste già un file CAD con questo nome del file.'
    },
    deleteTitle: 'Sei sicuro di voler eliminare questa visualizzazione 3D?',
    drawMode: {
      hiddenLines: 'Righe nascoste',
      label: 'Modalità Disegna',
      shaded: 'Ombreggiato',
      wireframe: 'Wireframe',
      wireframeShaded: 'Wireframe ombreggiato'
    },
    explode: 'Espandi',
    failureCreatingBomAssociations: 'Impossibile creare le associazioni della DiBA al modello 3D.',
    fileSizeModal: {
      message: 'La dimensione massima del file consentita in Documoto è di 25 megabyte. Il file che stai tentando di caricare supera il limite massimo e non può essere caricato. Clicca su “OK”  per continuare.',
      title: 'Dimensione massima del file superata'
    },
    fileSizeModalWarning: {
      message: 'La dimensione massima del file standalone consentita in Documoto è {size} megabyte. La dimensione di uno dei file che stai tentando di caricare supera il limite massimo consentito e non può essere caricato. Fai clic su “OK” per continuare.',
      title: 'Dimensione massima del file superata'
    },
    freeTierCurrentCount: 'Hai {count} modelli 3D gratuiti su 15 attivi. Una volta raggiunto il limite, non sarà più possibile pubblicare nuove pagine con modelli 3D. Contatta il tuo Customer Success Manager per aggiornare l’abbonamento.',
    freeTierExceededError: 'La pubblicazione di questa pagina con un modello 3D non è consentita.',
    freeTierExceededOption1: 'Contatta il tuo Customer Success Manager per aggiornare l’abbonamento.',
    freeTierExceededOption2: 'Rimuovi il modello 3D dalla bozza per pubblicare la pagina.',
    freeTierExceededTitle: 'Hai superato il limite di 15 modelli 3D attivi',
    illustrationLabel: 'Visualizza in 2D',
    invalidFile: 'File non valido inviato per il caricamento',
    mapModelToBom: 'Mappa modello alla DiBA',
    modelLabel: 'Modello 3D',
    modelLabelMobile: '3D',
    noBomPartsMatch3dPartNumbers: 'Impossibile trovare le parti della DiBa corrispondenti ai numeri di parte del modello 3D.',
    noPartsMatchRegEx: 'Nessuna parte della DiBa corrispondente all’espressione regolare',
    orientation: 'Orientamento',
    orientationAndProjection: {
      back: 'Indietro',
      bottom: 'Inferiore',
      front: 'Anteriore',
      isometric: 'Isometrico',
      left: 'Sinistra',
      orthographic: 'Ortografico',
      perspective: 'Prospettiva',
      projection: 'Proiezione',
      right: 'Destra',
      top: 'Superiore'
    },
    partNumberProperty: 'Proprietà Numero di parte',
    partNumberRegex: 'Regex Numero di parte',
    partNumbersInModel: 'Numeri di parte nel modello',
    resetCamera: 'Ripristina fotocamera',
    setAsDefaultView: 'Imposta come Visualizzazione predefinita',
    setAsDefaultViewTooltip: 'Imposta questo orientamento e il livello di zoom come visualizzazione iniziale predefinita.',
    slice: {
      label: 'Fetta',
      planeX: 'Piano di taglio X',
      planeY: 'Piano di taglio Y',
      planeZ: 'Piano di taglio Z',
      reset: 'Ripristina piano di taglio',
      section: 'Attiva/disattiva sezione piano di taglio',
      visibility: 'Attiva/disattiva visibilità piano di taglio'
    },
    successfullyCreatedBomAssociations: 'Associazioni della DiBa al modello 3D {count} create correttamente',
    successfullySavedDefaultView: 'Visualizzazione predefinita salvata correttamente',
    supportedFilesMessage: 'Documoto supporta numerosi formati di file CAD. Verifica con il Centro assistenza se non sei sicuro che il formato del tuo file CAD sia supportato.',
    threeD: '3D',
    toolsLabel: 'Strumenti 3D',
    topAssemblyFilename: 'Nome file dell’assemblaggio superiore',
    topAssemblyFilenameInvalid: 'Il file di assieme di livello superiore non è presente nell’elenco dei file',
    topAssemblyFilenameRequired: 'Il nome file dell’assemblaggio superiore è obbligatorio',
    viewerControls: 'Comandi del visualizzatore',
    viewerSettings: 'Impostazioni del visualizzatore 3D.',
    viewerTitle: 'Visualizzatore 3D'
  },
  thu: 'Gio',
  thumbnail: 'Anteprima',
  thumbnailDeleted: 'Cancellazione dell’Anteprima Riuscita',
  thumbnailDeletedError: 'Cancellazione dell’Anteprima Non Riuscita',
  thumbnailReapplyWarning: 'Il sistema può riapplicare una miniatura sulla base dei contenuti del medium. Potrebbe richiedere qualche minuto.',
  thumbnailResizeTooltip: 'Ridimensiona le anteprime a non più di 500x500 pixel, se selezionato',
  thumbnailUpdated: 'Aggiornamento dell’Anteprima Riuscito',
  thumbnailUpdatedError: 'Aggiornamento dell’Anteprima Non Riuscito',
  title: 'Titolo',
  to: 'A',
  toDate: 'Alla Data',
  toGetStarted: 'per iniziare.',
  toastNotifications: 'Notifiche Toast',
  toc: 'Toc',
  tocClipBoardSuccessTitle: 'Copiato negli Appunti',
  tocClipBoardWarningText: 'AVVISO: Le modifiche non salvate non possono essere copiate nei tuoi appunti',
  tocClipBoardWarningTitle: 'Copiato negli Appunti',
  tocDisplayingFirstValues: 'Visualizzazione dei primi 100 valori. Usa il filtro per vedere di più.',
  tocDuplicateWarningText: 'La pagina duplicata è stata individuata in un capitolo. Il duplicato è stato rimosso.',
  tocEmptyMessage: 'Sembra che tu non abbia ancora creato un Indice.',
  tocMissingChapterName: 'Nome Capitolo Mancante',
  tocModalTableCaption: 'Modalità Editore Tag',
  tocNothingSelected: 'Nessuna Selezione',
  tocOpenEditor: 'Editor Aperto',
  tocSaveRequired: 'Salvataggio richiesto prima di modificare i dettagli del capitolo',
  tocState: 'Stato Iniziale dell’Indice',
  tocThumbnailDeleteFailTitle: 'Cancellazione dell’Anteprima Non Riuscita',
  tocThumbnailDeleteSuccessTitle: 'Cancellazione dell’Anteprima Riuscita',
  tocThumbnailUploadFailTitle: 'Caricamento dell’Anteprima Non Riuscito',
  tocThumbnailUploadSuccessTitle: 'Caricamento dell’Anteprima Riuscito',
  tocTranslationMessage: 'Nome e descrizione opzionale di questo capitolo',
  tocUntitledPage: 'Pagina Senza Titolo',
  togglePage: 'Pagina di Attivazione',
  tooManySelections: 'L‘elenco supera il limite di selezione {limit}',
  top: 'In alto',
  total: 'Totale',
  totalItems: 'Elementi Totali',
  translation: 'Traduzione | Traduzioni',
  translationHelpTextItem: 'Nome e descrizione opzionale di questo {item}',
  'true': 'Vero',
  tryAgain: 'Si prega di riprovare.',
  trySearchingToc: 'Prova a cercare una qualsiasi parola che vedi o ricordi: l\'elenco verrà filtrato immediatamente. La visualizzazione non cambia finché non clicchi su un risultato.',
  tryThis: 'Prova',
  tue: 'Mar',
  turkishDescription: 'Descrizione in Turco',
  turkishName: 'Nome in Turco',
  twoSided: 'Fronte-retro',
  type: 'Tipo | Tipi',
  typeAtLeastTwoChars: 'Digita almeno 2 caratteri per visualizzare un elenco di corrispondenze.',
  typeSearchCriteriaAlreadySet: 'Eliminare i criteri di ricerca “Tipo” selezionati per applicare le modifiche.',
  typeToConfirm: 'Tipo {value} da confermare',
  typography: 'Tipografia',
  ukraineDescription: 'Descrizione in Ucraino',
  ukraineName: 'Nome in Ucraino',
  unableToRetrieveResults: 'Impossibile recuperare i risultati della query/ricerca',
  unauthorized: 'Non autorizzato',
  unknownError: 'Errore sconosciuto, contattare l’Assistenza Documoto a support{\'@\'}documoto.com per ricevere supporto',
  unknownInput: 'InputType sconosciuto:',
  unknownPart: 'Parte Sconosciuta',
  unknownType: 'Tipo non riconosciuto',
  unsavedAPIKeyWarning: 'La tua Chiave API andrà persa se non selezionerai Ritorna',
  unsavedChanges: 'Non hai salvato le modifiche. Continua?',
  unsavedChangesWarning: 'Le tue modifiche verranno perse se non le salvi.',
  unsavedWidgetKeyWarning: 'Se non torni, la tua chiave widget andrà persa.',
  unsupportedBrowserMessage: 'Quest’applicazione è stata costruita con la tecnologia più recente. Ciò rende l’applicazione più veloce e facile da utilizzare. Sfortunatamente, il tuo browser non supporta queste tecnologie.',
  untitledOrg: 'Organizzazione Senza Titolo',
  unverified: 'Non verificato',
  uom: 'UDM',
  update: 'Aggiorna',
  updateFailed: 'Aggiornamento non riuscito',
  updateIndex: 'Aggiorna l’Indice',
  updatePassword: 'Aggiorna la Password',
  updatePasswordMessage: 'Password aggiornata correttamente',
  updatePasswordPending: 'Cambio di password in attesa di salvataggio.',
  updated: 'Aggiornato',
  upgradeBrowser: 'Aggiornare il browser.',
  upload: 'Carica',
  uploadComplete: 'Caricamento Completato',
  uploadFileSizeLimitExceeded: 'il file supera il limite di dimensioni per la visualizzazione in-app.',
  uploadInProgress: 'Caricamento in Corso',
  uponSavingDisabledTenant: 'Al termine del salvataggio della pagina con questa impostazione abilitata, accadrà quanto segue:',
  uponSavingThisLicense: 'Al termine del salvataggio della pagina con questa impostazione, DEVI AGIRE COME SEGUE:',
  upperBound: 'Limite Superiore',
  usCurrency: 'USD',
  useDefaultCartColumns: 'Usare le Colonne del Carrello Predefinite',
  useDefaultPartsListColumns: 'Usare le Colonne Elenco delle Parti Predefinite',
  useSequentialPageNumbering: 'Usa Numerazione Pagine Sequenziale',
  useSniForSsoMetadataRetrieval: 'Utilizza SNI per recuperare i metadati SSO',
  user: 'Utente',
  userAddress: 'Indirizzi Utente | Indirizzi Utente',
  userCount: 'Conteggio Utenti',
  userEditable: 'Modificabile dall’Utente',
  userExpirationDate: 'Data di scadenza dell’utente',
  userExpirationDateInvalid: 'Inserire la data di scadenza dell’utente',
  userGroup: 'Gruppo Utente | Gruppi Utenti',
  userGroupEmpty: 'I Gruppi Utenti non possono essere vuoti',
  userGroupType: 'Tipo gruppo utente',
  userGroupUniqueMessage: 'Questo nome deve essere diverso da tutti gli altri nomi del Gruppo Utente per questo proprietario',
  userGroupUsers: 'Utenti del Gruppo Utente',
  userSettings: 'Impostazioni utente',
  userVerificationEmailBody: 'Corpo e-mail di verifica dell’utente',
  userVerificationEmailFieldsValidation: 'I campi E-mail di verifica dell’utente devono essere entrambi vuoti o non vuoti',
  userVerificationEmailSubject: 'Oggetto E-mail di verifica dell’utente',
  username: 'Nome Utente',
  usernameEmpty: 'Il campo username non può essere vuoto',
  users: 'Utenti',
  usersWillReceiveAnUnauthorizedError: 'Gli utenti riceveranno un errore “Non autorizzato” quando tenteranno di accedere al tenant.',
  validate: 'Convalida',
  validateTenantDirectories: {
    buttonLabel: 'Convalida Directory di contenuto',
    error: 'Convalida delle directory non riuscita',
    success: 'Directory del titolari convalidate'
  },
  validationMessage: 'Messaggio di Convalida | Messaggi di Convalida',
  value: 'Valore',
  valueGteError: 'Il valore deve essere inferiore o uguale a {max}',
  valueLteError: 'Il valore deve essere superiore o uguale a {min}',
  variantSKU: 'Variante SKU',
  vendorName: 'Nome fornitore',
  verificationEmailRequested: 'L’e-mail di verifica verrà inviata al salvataggio.',
  verificationEmailSent: 'E-mail di verifica inviata.  Password non impostata.',
  verified: 'Verificato',
  verifyPassword: 'Verifica Password',
  verifying: 'Verifica in corso',
  version: 'Versione',
  vertical: 'Verticale',
  video: 'Video | Video',
  view: 'Visualizza',
  viewAll: 'Visualizza tutto',
  viewAllPagesAndBooks: 'Vista: Tutte le pagine e i libri',
  viewAllResults: 'Visualizza tutti i risultati',
  viewBooks: 'Vista: Libri',
  viewModeList: 'Elenco',
  viewModeTable: 'Tabella',
  viewMore: 'Visualizza altro',
  viewPages: 'Vista: Pagine',
  viewWhereUsed: 'Visualizza dove usato',
  views: 'Visualizzazioni',
  visibility: 'Visibilità',
  visibilityDescription: 'Chi può vedere questo {entity}',
  visible: 'Visibile',
  waitForUpload: 'Attendere il completamento del caricamento.',
  watermark: 'Watermark',
  watermarkFont: 'Carattere watermark',
  watermarkOpacityPercentage: '% opacità watermark',
  watermarkOrientation: 'Orientamento watermark',
  watermarkSaveFailed: 'Impossibile salvare watermark.',
  watermarkSaved: 'Watermark salvato',
  watermarkSelectionRequired: 'Selezione Nome utente o Testo richiesti.',
  watermarkText: 'Testo watermark',
  wed: 'Mer',
  whereUsed: 'Dove Si Usa',
  whereUsedCountInSearchBar: 'Conteggio dove usato nella barra di ricerca',
  whoCanViewComment: 'Chi può vedere questo commento?',
  wholesale: 'Vendita All’Ingrosso',
  wholesalePrice: 'Prezzo All’Ingrosso',
  wholesaleTotal: 'Totale Vendita All’Ingrosso',
  widget: 'Widget',
  widgetAuthHeader: 'Valore autorizzazione widget',
  widgetErrorConfig: 'Impossibile inizializzare il widget a causa di una configurazione non valida',
  widgetErrorInit: 'Impossibile inizializzare il widget Documoto',
  widgetErrorLocation: 'Impossibile trovare il contenuto specificato nel widget',
  widgetErrorMultipleLocations: 'Sono state trovate più posizioni per il contenuto specificato',
  widgetKey: 'Chiave widget | Chiavi widget',
  widgetKeyAdmin: 'Ammin chiave widget',
  widgetKeyCopied: 'Valore autorizzazione widget copiato negli Appunti',
  widgetKeyDeleteMsg: 'L’eliminazione della chiave widget ne disabiliterà l’uso',
  widgetKeyDeleted: 'Chiave widget eliminata',
  widgetKeyDeletedError: 'Errore durante l’eliminazione della chiave widget',
  widgetKeyManager: 'Gestione chiave widget',
  widgetKeyNameEmpty: 'Il nome deve essere univoco ed è obbligatorio. Questo valore sarà utilizzato anche per scopi di reporting e accesso come nome utente per qualsiasi attività del widget',
  widgetKeyRegenError: 'Errore durante la rigenerazione della chiave widget',
  widgetKeyRegenMsg: 'La rigenerazione di questa chiave widget potrebbe disabilitare le integrazioni esistenti',
  widgetKeyRegenTitle: 'Rigenerare questa chiave widget?',
  widgetKeySaved: 'Chiave widget salvata',
  widgetPermissions: 'Gli utenti widget sono di sola lettura, e l’accesso alla funzione è gestito dalla configurazione a livello di widget. Le autorizzazioni del gruppo utente standard non si applicano agli utenti widget. Privilegi di accesso alla Categoria Media. Procedere per assegnare i controlli di accesso della categoria dei media.',
  widgetRefreshErrorMsg: 'Aggiornare la pagina per visualizzare il contenuto richiesto',
  widgetUserGroup: 'Gruppo utente widget',
  widgetUserGroupDeleteMsg: 'Impossibile eliminare il gruppo widget con utenti',
  willBeAffected: 'sarà interessato.',
  willBeDeleted: '{content} verrà cancellato.',
  willBeInsertedIntoItem: '{name} verrà inserito in {item}',
  willBeUpdated: 'sarà aggiornato.',
  year: 'Anno',
  yourEmailAddress: 'Indirizzo e-mail',
  zipCode: 'Codice Postale',
  zoomHotpointToCanvas: 'Aumenta Hotpoint alla dimensione Canvas',
  zoomIn: 'Ingrandisci',
  zoomOut: 'Rimpicciolisci'
};
/* eslint-enable max-len */
